<template>
<div id="cardApp" class="app-wrapper">
<!-- 无 token 时显示拒绝访问页面 -->
<div v-if="!tokenValid && !loading" class="access-denied">
<div class="denied-content">
<h1>⚠️ Access Denied</h1>
<p>Invalid or missing token. Please contact administrator.</p>
<el-button @click="goHome">Return to Home</el-button>
</div>
</div>
<!-- 有 token 时显示正常页面 -->
<div v-else-if="tokenValid" class="main-wrapper">
<main class="content-main">
<img src="@/assets/hktcmbanner.jpg" style="width:100%" />
<img src="@/assets/hktcmbg.jpg" style="width:100%" />
<div class="page-title-row" style="display: flex; justify-content: space-between; align-items: center;">
<h3 style="margin: 0;">Prepaid Card Application</h3>
</div>
<div class="apply-section">
<div class="apply-item">
<div class="apply-info">
<div class="apply-title">Existing Trust Client Application</div>
<div class="apply-desc">Applicable only to customers who do not need to change their existing mobile phone number, mailing address, nationality, or other information with this bank.</div>
</div>
<div class="apply-btn apply-btn-primary" @click="startApplication">Apply Now</div>
</div>
<div class="apply-item">
<div class="apply-info">
<div class="apply-title">Approval Status</div>
<div class="apply-desc">Check Prepaid Card Approval Status</div>
</div>
<div class="apply-btn apply-btn-secondary" @click="openQueryDialog">Check Approval Status</div>
</div>
</div>
<div style="margin-top: 20px; padding: 15px; background: #f8f9fa; border-radius: 8px; font-size: 13px; color: #666;">
Online applications are not processed immediately and should not be used for urgent submissions. For any inquiries, please contact us promptly via email.
</div>
</main>

<!-- 条款及细则弹窗 -->
<el-dialog :visible.sync="termsVisible" title="Terms and Conditions" width="850px" class="terms-dialog" :close-on-click-modal="false">
<div class="terms-header">HKTCM Global Visa Prepaid Card Terms and Conditions</div>
<div class="terms-content" ref="termsContentRef" @scroll="handleTermsScroll">
<p><strong>Important Notice! These Terms andConditions may regulate your use of the HKTCM Global VISA Prepaid  Card  (hereinafter referred to as “Prepaid Card”)arranged or facilitated by Hong Kong Trust Capital Management Limited (HKTCM) (the ‘Company’, ‘we’,“us” or ‘our’) and its partners. Please read these Terms and Conditionscarefully before using the Prepaid Card. Your use (including activation) of the Prepaid Cardshall be deemed to constitute your acceptance of and agreement to be bound bythese Terms and Conditions. Definitions of terms used in these Terms andConditions are set out at the end of these Terms and Conditions.</strong></p>
<p><strong>Qualifications and Registration</strong></p>
<p>1.We reserve the right to take the following actions at any time:<br>
a)Modify, update, or alter these terms and conditions; or<br>
b)Charges, fees, or other conditions may apply for the use of this service or any part thereof (subject to reasonable advance notice).<br>
(All of the above shall collectively be referred to as the "Amendments").</p>
<p>2. We may modify these Terms at any time without notice (except as otherwise provided in paragraph (b) above). Any changes to these Terms may be posted on our website or notified to you via email using the email address provided in your account. Therefore, you should regularly review our website, enable receipt of such push notifications, and ensure the email address and other contact information in your account remain up to date. Your continued use of the Services after such changes take effect constitutes your acceptance of those changes.</p>
<p>3.You must:<br>
a)  Existing trust clients of the Company with account assets meeting the corresponding tier threshold.<br>
b)  Have reached the legal age and possess the capacity to enter into contracts under applicable law.<br>
c)	Reside in a jurisdiction determined by the Company and its partners to be eligible for card issuance.<br>
d)  Comply with all applicable laws, including Anti-Money Laundering (AML) and Know Your Customer (KYC) requirements.<br>
e)  Provide all verification and identity documents as requested by the Company or its partners.</p>
<p>4.You agree to ensure that your registration information is accurate and updated in a timely manner. Failure to do so may result in the suspension or termination of your service access privileges.</p>
<p>5.The company reserves the right to modify, suspend, or terminate your access to the services at any time and at its sole discretion.</p>
<p><strong>Regarding the Prepaid Card</strong></p>
<p>6.This card is a prepaid card. Your card account is not a checking orsavings account and is not linked to any other account you hold, except forcash sub-accounts within trust accounts. This card is not a gift card andcannot be given to others. This card is not a prepaid card, so you may not havethe same rights associated with prepaid card transactions. Funds in your cardaccount do not earn interest.</p>
<p>7.You may access your account balance through your prepaid card. Youshall be subject from time to time to these Terms and Conditions and otherterms governing your account and the applicable payment network or platform. Inthe event of any inconsistency between these Terms and other terms, these Termsand Conditions shall prevail in relation to your prepaid card and any services.</p>
<p>8.The ownership of the prepaid card in your possession belongs to ourcompany. When our company requests its return in accordance with the relevantterms and conditions, you are obligated to return it.</p>
<p>9.The Company may provide, modify, suspend, revoke, or cancel anyservice, account card, or your use of the account card at any time withoutprior notice. The Company may also add, modify, restrict, suspend, revoke, orcancel all or any rights, services, facilities, and privileges related to youraccount card. Upon cancellation of the account card, the full amount of anytransaction made using the account card or authentication factor shall beimmediately payable.</p>
<p><strong>Your responsibility</strong></p>
<p>10.Even in the following circumstances, you shall remain liable:<br>
i）You did not sign the sales slip (including where the transaction may be conducted by telephone, mail, electronic means, or direct payment arrangement without requiring a sales slip or your signature); or the signature on the sales slip differs from the signature on your prepaid card; or<br>
ii）The transaction was not conducted with your consent.</p>
<p>11.The account cardholder shall be responsible for the following matters:<br>
i All transactions made using the Prepaid Card and authentication factors (including all related fees and charges), including those made with the cardholder's own Prepaid Card and authentication factors and those made with the Prepaid Card and authentication factors of any supplementary cardholder; and<br>
ii）The primary cardholder and any supplementary cardholder have failed to comply with these terms and conditions.<br>
a)	The supplementary cardholder shall be responsible for the use of his/her own prepaid card and authentication factors, but shall not be liable for the use of their prepaid card or authentication factors by the primary cardholder or any other supplementary cardholder.<br>
b)	Whether or not you are aware of it, you should not use your prepaid card for any transaction that may violate the laws of any jurisdiction.<br>
c)	Even if your account card has been terminated, you remain responsible for this.</p>
<p>12. You agree that when the prepaid card or authentication factor isused to conduct, process, or execute any transaction, it shall be deemed thatyou have authorized and are aware of such use, regardless of whether you haveactually authorized and/or are aware of such use of the prepaid card orauthentication factor. The Company shall debit your account for any amountincurred through transactions or processing using the prepaid card orauthentication factor. The Company's records of all transactions conductedusing the prepaid card or authentication factor shall be deemed accurate andfinal (except for obvious errors), and you agree to be bound by such records.</p>
<p><strong>Safety and Security Measures</strong></p>
<p>13.You should take appropriate security precautions, including the following:<br>
a)	Sign your account card immediately upon receipt.<br>
b)	Safeguard your prepaid card and mobile device and keep them in your possession at all times. Treat your prepaid card with the same care you would cash.<br>
c)	After using the ATM, remember to retrieve your prepaid card.<br>
d)	Ensure that merchants promptly return the prepaid card to you after completing the prepaid card transaction.<br>
e)	Keep your authentication factors and device passwords strictly confidential;<br>
f)	When using authentication factors and device passwords, please ensure that neither the authentication factors nor the device passwords are visible to others.<br>
g)	Regularly change your personal password and device passcode;<br>
h)	If your personal password or device passcode has been or may have been viewed by others, you should change it immediately.<br>
i)	Never write down your authentication factors or device passcode, nor record them on your prepaid card, store them with your prepaid card, or handle them in any other way that could allow others to use your prepaid card, authentication factors, or mobile device. You should obscure any records of your authentication factors or device passcode.<br>
j)	Never use easily guessable numbers as your personal password or device passcode (such as ID numbers, birth dates, phone numbers, or other readily accessible personal information) and use alphanumeric codes where applicable;<br>
k)	Do not use the same private password or device password for other services or purposes, such as connecting to the internet or logging into other websites.<br>
l)	Do not transfer your prepaid card, authentication factors, device passcode, or mobile device, nor permit any other person to use your prepaid card, authentication factors, device passcode, or mobile device.<br>
m)	Each time you make a purchase, remember to fill in the total amount on the receipt and include the currency code before the amount. Do not leave any spaces for others to fill in.<br>
n)	Ensure that only one receipt is printed per transaction;<br>
o)	Retain the cardholder stub of each Prepaid Card transaction slip and reconcile it with the Prepaid Card statement or records; and<br>
p)	Please ensure that the contact information you have registered with our company for receiving important notifications (such as SMS and email notifications for online payments) is up to date so that such notifications can be delivered to you in a timely manner.</p>
<p><strong>Report immediately if your account card, authentication factor, or mobile device is lost, stolen, or misused.</strong></p>
<p>14.If your prepaid card, authentication factor, or mobile device is lost, stolen, compromised, or used without authorization, you must promptly report this to us and provide written confirmation as soon as reasonably practicable. You remain liable for all transactions made using your prepaid card or authentication factor prior to our receipt of your report.</p>
<p>15. Without limiting or impairing the effect of Section 17(a), if your account statement shows any transaction not authorized by you, you shall promptly notify the Company. You must submit a chargeback request to the Company within 45 days after the transaction. If you fail to notify us within this 45-day period, the transaction shall be deemed correct, final, and binding upon you, and you shall be deemed to have waived any right to raise objections or seek remedies against us in relation to such transaction.</p>
<p><strong>Your Liability for Unauthorized Transactions</strong></p>
<p>16.	If you report the loss, theft, compromise, or unauthorized use of your prepaid card, authentication factor, or mobile device under Section 14(b), your liability for unauthorized transactions will be determined on a case-by-case basis.</p>
<p>17. If you knowingly (whether voluntarily or not) permit any otherperson to use your prepaid card, authentication factor, or mobile device; or ifyou commit fraud or act with gross negligence in the use or custody of yourdebit card, authentication factor, or mobile device. Failure to implement anysecurity measures recommended by us from time to time regarding the use orcustody of your debit card, authentication factor, or mobile device may bedeemed gross negligence on your part, and you may be held liable for thetransaction amount.</p>
<p><strong>Compensation</strong></p>
<p>18.	To the fullest extent permitted by law, you agree to indemnify and hold harmless the Company (and all its affiliated entities, directors, officers, subsidiaries, employees, service providers, members, representatives, and agents, collectively referred to as the "Indemnified Parties") from and against any and all claims, demands, actions, proceedings, liabilities, losses, damages, penalties, penalties, fines, expenses, and costs (including reasonable legal fees as determined by a court of competent jurisdiction) incurred by the Company (and all of its affiliated entities, directors, officers, subsidiaries, employees, service providers, members, representatives, and agents, collectively referred to as the "Indemnified Parties") in connection with:<br>
a)	Your conduct and your use of our services;<br>
b)	You violate these Terms or our Anti-Money Laundering ("AML") policy;<br>
c)	You violate any law, regulation, or rule;<br>
d)	You violate or infringe upon the Company's copyrights, intellectual property rights, trade secrets, patents, trademarks, service marks, or any other legally protected proprietary rights;<br>
e)	You have failed to properly safeguard or maintain the confidentiality of your account card credentials or any other identity verification data as required under Article 16;<br>
f)	Any damages caused by you to our services, any user, or any other individual or entity; or<br>
g)	Any rights exercised by the Company pursuant to these terms.</p>
<p>19.	This indemnification includes, but is not limited to, liabilities related to intellectual property, defamation, and invasion of privacy.</p>
<p><strong>Disclaimer and Exceptions</strong></p>
<p>20.	The Company shall not be liable to you or any other person for any of the following (or any one thereof):<br>
a)	Any failure or delay by the Company in providing any services, equipment, or other facilities to you that may be attributable to circumstances beyond the Company's reasonable control;<br>
b)	The availability or performance of any point-of-sale terminal or other device provided or operated by a merchant or any other person for the use of a prepaid card or any of its features (including contactless payment functionality); and<br>
c)	Consequential or indirect losses arising from or in connection with the use of your prepaid card or authentication factor.</p>
<p>21The Company shall not be liable for any merchant's refusal to accept your prepaid card or authentication factor. The Company shall also not be liable for any goods or services provided to you by any merchant. Your obligations to the Company under these Terms and Conditions shall not be affected, waived, or reduced by any claim you may have against a merchant. You shall be solely responsible for resolving any disputes with merchants. In particular, you and the merchant must agree to establish, modify, or terminate any automatic transfer or direct debit arrangement for charging payments to your account. In the event of any dispute between you and the merchant, the Company reserves the right not to execute any request to establish, modify, or terminate such arrangements.</p>
<p>22.Even if any merchant fails to provide goods or services or fails to fulfill its obligations, or if any goods or services provided by any merchant are defective, or if any merchant fails to provide you with any goods, services, offers, discounts, or programs, the Company reserves the right to deduct from your account all transactions made using your prepaid card or authentication factors. You must seek redress directly from the relevant merchant regarding such goods, services, offers, discounts, or programs.</p>
<p>23.	The Company reserves the right to convert the refund amount into another currency at a time and exchange rate deemed appropriate by the Company. You shall bear all related exchange rate risks, losses, commissions, and other charges and fees.</p>
<p>24.	Under no circumstances shall the Company, its affiliates, service providers, or any of their respective officers, directors, agents, partners, employees, or representatives be liable for:<br>
a)	Any loss of profits, goodwill or reputation, loss of data, impairment of value or business opportunities, loss, damage, deterioration, or disclosure of any data or other intangible property, or any special, incidental, indirect, intangible, or consequential damages arising out of or in connection with the use of the Company's website or services or this Agreement, whether based on contract, tort, negligence, strict liability, or otherwise, even if the Company has been advised of, knew of, or ought to have known of the possibility of such damages, and even if any agreed-upon or other remedy fails of its essential purpose. The Company shall not be liable for such damages unless a final judicial determination establishes that such damages resulted from the Company's gross negligence, fraud, or intentional misconduct, or intentional violation of law.</p>
<p><strong>Governing Law and Dispute Resolution</strong></p>
<p>25.	These terms shall be governed by and construed in accordance with the laws of Hong Kong, without regard to its conflict of laws principles.</p>
<p>26.	If you are a consumer and have any complaints, we encourage you to first contact our customer service team via our website www.hongkongtrust.com.hk and email info@hktcm.com.</p>
<p>27.	If the complaint is not resolved to your satisfaction, you may refer the matter to the Hong Kong Mediation and Arbitration Centre for mediation, followed by arbitration at the Hong Kong International Arbitration Centre in accordance with its then-current Arbitration Rules ("HKIAC Rules"). Should mediation fail, such rules shall be deemed incorporated by reference into these Terms.</p>
<p>28.	The language of the arbitration shall be English. The place of arbitration shall be Hong Kong. Unless otherwise determined by the arbitral tribunal, each party shall bear its own arbitration costs.</p>
</div>
<div class="terms-footer">
<div class="terms-checkbox">
<input type="checkbox" id="termsAgree" v-model="termsAgreed" :disabled="!canAgree">
<label for="termsAgree" class="terms-checkbox-label">
I confirm that I have read and agree to the 'HKTCM Global Visa prepaid card Terms and Conditions.'<br>
<span>Please check this box to confirm you have read and agree to the terms before proceeding with the application.</span>
</label>
</div>
<div class="terms-actions">
<el-button @click="closeTermsDialog" class="terms-cancel">Cancel</el-button>
<el-button @click="acceptTerms" :disabled="!termsAgreed" class="terms-accept">Accept</el-button>
</div>
</div>
</el-dialog>

<!-- 申请表单弹窗 -->
<el-dialog :visible.sync="applicationFormVisible" title="Prepaid Card Application Form" class="application-form-dialog" width="1400px" append-to-body>
<div class="step-nav">
<div class="step">
<div class="step-number" :class="{ 'active': currentStep === 1 }">1</div>
<div class="step-label" :class="{ 'active': currentStep === 1 }">Applicant & Account</div>
</div>
<div class="step-connector" :class="{ 'active': currentStep >= 2 }"></div>
<div class="step">
<div class="step-number" :class="{ 'active': currentStep === 2 }">2</div>
<div class="step-label" :class="{ 'active': currentStep === 2 }">Cardholder Information</div>
</div>
</div>

<div v-if="currentStep === 1" class="form-section">
<h3 class="section-title">Applicant and Trust Account Information</h3>
<div class="preview-title" style="margin-bottom: 20px;">
Applicant: {{ formData.Name }}
</div>
<!-- 第一组：基本身份信息 -->
<div class="form-group-title">Basic Identity Information</div>
<div class="part-a-grid">
<div class="form-group">
<label class="form-label">Trust account number</label>
<el-input v-model="formData.username" readonly class="form-input readonly-input"></el-input>
</div>
<!-- 🔹 新增：流水号显示 -->
<div class="form-group">
<label class="form-label">Application No.</label>
<el-input v-model="formData.busiWaterNo" readonly class="form-input readonly-input" placeholder="Auto-generated"></el-input>
</div>
<div class="form-group">
<label class="form-label">Name (Legal)</label>
<el-input v-model="formData.Name" placeholder="Please enter your name" class="form-input readonly-input" readonly></el-input>
</div>
<div class="form-group">
<label class="form-label">English Name<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.englishName" @input="handleEnglishNameInput" placeholder="Please enter English name (A-Z, spaces only)" class="form-input required-input" maxlength="50"></el-input>
</div>
<div class="form-group">
<label class="form-label">Gender</label>
<el-select v-model="formData.gender" placeholder="Please select" class="form-input title-select readonly-input" readonly>
<el-option label="Male" value="male"></el-option>
<el-option label="Female" value="female"></el-option>
</el-select>
</div>
</div>

<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group">
<label class="form-label">Nationality</label>
<el-input v-model="formData.nationality" placeholder="Please enter your nationality" class="form-input readonly-input" readonly></el-input>
</div>
<div class="form-group">
<label class="form-label">Date of Birth<span style="color: #EF4444;">*</span></label>
<el-date-picker v-model="formData.dateOfBirth" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
<div class="form-group">
<label class="form-label">National Identity Card Number/Passport <span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.idNumber" placeholder="Please enter your identification number" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">ID Type<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.idType" placeholder="Select ID Type" class="form-input required-input" @change="handleIdTypeChange">
<el-option label="Mainland Resident Permit" value="MainlandID"></el-option>
<el-option label="Hong Kong Identity Card" value="HKID"></el-option>
<el-option label="Passport" value="Passport"></el-option>
<el-option label="Other" value="Other"></el-option>
</el-select>
</div>
</div>

<!-- 第二组：证件详细信息 -->
<div class="form-group-title" style="margin-top: 25px;">ID Document Details</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group">
<label class="form-label">ID Issue Date<span style="color: #EF4444;">*</span></label>
<el-date-picker v-model="formData.idIssueDate" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
<div class="form-group" v-if="formData.idType !== 'HKID' && formData.idType !== 'Other'">
<label class="form-label">ID Expiry Date <span style="color: #EF4444;">*</span></label>
<el-date-picker v-model="formData.idExpiryDate" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">ID Card Address<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.idAddress" type="textarea" :rows="2" placeholder="Address as shown on ID document" class="form-input required-input"></el-input>
</div>
</div>

<!-- 第三组：证件上传 -->
<div class="form-group-title" style="margin-top: 25px;">ID Document Upload<span style="color: #EF4444;">*</span></div>
<div class="upload-section" style="margin-top: 20px; padding: 20px; background: #f8f9fa; border-radius: 8px;">
<div class="upload-notice" style="margin-bottom: 15px; color: #666; font-size: 13px;">
<strong>📋 Upload Requirements:</strong>
<ul style="margin: 8px 0 0 20px; padding: 0;">
<li>Mainland ID: Front (Portrait) + Back (Emblem) pages required</li>
<li>HK ID: Information page required</li>
<li>Passport/Other: Information page required</li>
<li>File format: JPG, PNG, or PDF | Max size: 5MB per file</li>
</ul>
</div>
<div class="part-a-grid">
<div class="form-group" v-if="formData.idType === 'MainlandID'">
<label class="form-label">ID Front (Portrait) <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocFrontFileList" :on-change="(file) => handleIdUpload(file, 'idDocFrontUrl', 'idDocFrontFileList')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf" class="upload-component">
<el-button size="small" type="primary">Upload Front</el-button>
</el-upload>
<div v-if="formData.idDocFrontFileList.length > 0" class="file-status" style="font-size: 12px; color: #10b981; margin-top: 5px;">✓ {{ formData.idDocFrontFileList[0].name }}</div>
</div>
<div class="form-group" v-if="formData.idType === 'MainlandID'">
<label class="form-label">ID Back (Emblem) <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocBackFileList" :on-change="(file) => handleIdUpload(file, 'idDocBackUrl', 'idDocBackFileList')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf" class="upload-component">
<el-button size="small" type="primary">Upload Back</el-button>
</el-upload>
<div v-if="formData.idDocBackFileList.length > 0" class="file-status" style="font-size: 12px; color: #10b981; margin-top: 5px;">✓ {{ formData.idDocBackFileList[0].name }}</div>
</div>
<div class="form-group" v-if="formData.idType === 'HKID'">
<label class="form-label">ID Information Page <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocInfoFileList" :on-change="(file) => handleIdUpload(file, 'idDocInfoUrl', 'idDocInfoFileList')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf" class="upload-component">
<el-button size="small" type="primary">Upload ID Page</el-button>
</el-upload>
<div v-if="formData.idDocInfoFileList.length > 0" class="file-status" style="font-size: 12px; color: #10b981; margin-top: 5px;">✓ {{ formData.idDocInfoFileList[0].name }}</div>
</div>
<div class="form-group" v-if="formData.idType === 'Passport' || formData.idType === 'Other'">
<label class="form-label">Passport/ID Information Page <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocInfoFileList" :on-change="(file) => handleIdUpload(file, 'idDocInfoUrl', 'idDocInfoFileList')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf" class="upload-component">
<el-button size="small" type="primary">Upload Page</el-button>
</el-upload>
<div v-if="formData.idDocInfoFileList.length > 0" class="file-status" style="font-size: 12px; color: #10b981; margin-top: 5px;">✓ {{ formData.idDocInfoFileList[0].name }}</div>
</div>
</div>
</div>

<!-- 第四组：联系信息 -->
<div class="form-group-title" style="margin-top: 25px;">Contact Information</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group">
<label class="form-label">Telephone<span style="color: #EF4444;">*</span></label>
<div style="display:flex; gap:8px;">
<el-select v-model="formData.phoneCode" filterable placeholder="Code" style="width: 240px;" class="form-input">
<el-option label="+852 HK" value="+852" />
<el-option label="+86 CN" value="+86" />
<el-option label="+853 MO" value="+853" />
<el-option label="+886 TW" value="+886" />
<el-option label="+65 SG" value="+65" />
<el-option label="+60 MY" value="+60" />
<el-option label="+971 AE" value="+971" />
<el-option label="+82 KR" value="+82" />
<el-option label="+81 JP" value="+81" />
<el-option label="+66 TH" value="+66" />
<el-option label="+1 US/CA" value="+1" />
<el-option label="+44 UK" value="+44" />
<el-option label="+61 AU" value="+61" />
</el-select>
<el-input v-model="formData.phone" @input="handlePhoneInput(1, $event.target.value)" placeholder="Phone number" class="form-input required-input"></el-input>
</div>
</div>
<div class="form-group">
<label class="form-label">Email address<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.email" placeholder="Please enter your email address" type="email" class="form-input required-input"></el-input>
</div>
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Postal Address (Mailing)<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.address" type="textarea" :rows="2" placeholder="Please enter your full postal address" class="form-input required-input"></el-input>
</div>
</div>

<!-- 第五组：职业与合规信息 -->
<div class="form-group-title" style="margin-top: 25px;">Professional & Compliance Information<span style="color: #EF4444;">*</span></div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group">
<label class="form-label">Occupation Type<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.occupation" placeholder="Select Occupation" class="form-input required-input">
<el-option v-for="opt in industryOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Position<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.jobTitle" placeholder="Select Position" class="form-input required-input">
<el-option v-for="opt in positionOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Years of Service<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.yearsOfService" placeholder="e.g. 5 years" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">Yearly Income<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.yearlyIncome" placeholder="e.g. 500000" class="form-input required-input"></el-input>
</div>
</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Company Name<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.companyName" placeholder="Please enter company name" class="form-input required-input"></el-input>
</div>
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Office Address<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.officeAddress" type="textarea" :rows="2" placeholder="Please enter office address" class="form-input required-input"></el-input>
</div>
</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group">
<label class="form-label">Office Tel. No.<span style="color: #EF4444;">*</span></label>
<div style="display:flex; gap:8px;">
<el-select v-model="formData.officeTelCode" filterable placeholder="Code" style="width: 240px;" class="form-input">
<el-option label="+852 HK" value="+852" />
<el-option label="+86 CN" value="+86" />
<el-option label="+853 MO" value="+853" />
<el-option label="+886 TW" value="+886" />
<el-option label="+65 SG" value="+65" />
<el-option label="+60 MY" value="+60" />
<el-option label="+971 AE" value="+971" />
<el-option label="+82 KR" value="+82" />
<el-option label="+81 JP" value="+81" />
<el-option label="+66 TH" value="+66" />
<el-option label="+1 US/CA" value="+1" />
<el-option label="+44 UK" value="+44" />
<el-option label="+61 AU" value="+61" />
</el-select>
<el-input v-model="formData.officeTel" placeholder="Office number" class="form-input required-input"></el-input>
</div>
</div>
<div class="form-group">
<label class="form-label">Purpose of Account<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.accountPurpose" placeholder="Select Purpose" class="form-input required-input" @change="handlePurposeChange">
<el-option v-for="opt in purposeOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Source of Wealth<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.sourceOfWealth" placeholder="Select Source" class="form-input required-input" @change="handleWealthChange">
<el-option v-for="opt in wealthOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group" v-if="formData.sourceOfWealth === '07'">
<label class="form-label">Source of Wealth (Please note)<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.sourceOfWealthOther" placeholder="Please specify" class="form-input required-input"></el-input>
</div>
</div>

<!-- ✅ 新增：支付密码设置 -->
<div class="form-group-title" style="margin-top: 25px;">Account Security</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group">
<label class="form-label">Payment Password<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.paymentPassword" type="password" placeholder="Please enter 6-digit payment password" class="form-input required-input" maxlength="6" show-password></el-input><span>Please enter six digits (numbers only)</span>
</div>
</div>
</div>

<div v-if="currentStep === 2" class="form-section">
<h3 class="section-title">Prepaid Card Distribution Information</h3>
<div style="font-size: 14px; margin-bottom: 20px; color: var(--text-secondary);">
Prepaid Card will be issued to (name must not exceed 20 characters, including spaces)
</div>
<!-- ============ 主卡 ============ -->
<div style="margin-bottom: 25px;">
<div style="font-weight: bold; margin-bottom: 8px;">Name on the card</div>
<div style="font-size: 13px; color: var(--text-secondary); margin-bottom: 8px;">
Names must be provided in English only (e.g., John Smith). Chinese characters, numbers, or special symbols are not permitted.
</div>
<div style="display: flex; align-items: center; margin-bottom: 16px; gap: 12px; flex-wrap: wrap;">
<span style="min-width: 100px;">Primary cardholder:</span>
<div style="flex: 1; position: relative;">
<el-input v-model="formData.cardName1" @input="handleCardName1Input" placeholder="Please enter English name only (e.g. John Smith)" class="form-input" :class="{ 'required-input': formData.cardName1 && formData.cardName1.trim() }"></el-input>
<span class="char-counter" :class="getCharCountClass(formData.cardName1 ? formData.cardName1.length : 0)" style="position: absolute; right: 10px; bottom: 8px; font-size: 12px;">{{ formData.cardName1 ? formData.cardName1.length : 0 }}/20</span>
</div>
</div>
<div style="display: flex; align-items: center; gap: 16px; margin-left: 100px; margin-bottom: 20px;">
<span>Application Category:</span>
<template v-for="option in availableCardTypes">
<label :key="option.value" style="display: flex; align-items: center; gap: 4px; cursor: pointer;" v-if="option.visible">
<input type="radio" v-model="formData.cardType1" :value="option.value" :name="'cardType1'"> {{ option.label }}
</label>
</template>
</div>
<div v-if="formData.cardType1" class="card-preview">
<img :src="getCardImage(formData.cardType1, formData.showLogoOnCard1)" alt="Prepaid Card Preview"/>
<div v-if="formData.showNameOnCard1" class="name-overlay" :style="{ color: formData.cardType1 === 'black' ? '#d6c6a4' : '#ffffff' }">{{ formData.cardName1 || 'Contact Information' }}</div>
</div>
<div v-if="formData.cardType1" style="margin-top: 10px; display: flex; gap: 20px; font-size: 13px; color: var(--text-secondary);">
<label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
<input type="checkbox" v-model="formData.showNameOnCard1"> Display Cardholder's Name
</label>
<label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
<input type="checkbox" v-model="formData.showLogoOnCard1"> Display Company Logo
</label>
</div>
<!-- ✅ 主卡电子签名 - 使用 SignaturePad 组件 -->
<div class="signature-section" style="margin-top: 30px; padding: 20px; background: #f8f9fa; border-radius: 8px; border: 1px solid #e2e8f0;">
<div class="form-group-title" style="margin-top: 0;">Electronic Signature - Primary Cardholder</div>
<div class="declaration-text" style="margin: 15px 0; padding: 15px; background: #fff; border: 1px solid #ddd; border-radius: 4px; font-size: 13px; line-height: 1.6; max-height: 200px; overflow-y: auto;">
<p style="margin-bottom: 10px;"><strong>I (The Applicant) hereby declare that after signing in the signature column herein below by myself (the Applicant), indicated that I have already fully read, understood, agreed, confirmed and accepted:</strong><br>
<strong>本人 (申請人) 謹此聲明，當本人於下列簽署欄內簽署後，即表示本人已細閱、同意、明白、確認及遵守以下各項聲明：</strong></p>
<ul style="padding-left: 20px; margin: 0;">
<li style="margin-bottom: 8px;">Applicant must apply HKTCM Global VISA Prepaid Card in Hong Kong and aged 18 or above. HKTCM 環球VISA 預付卡申請人須為年滿 18 歲及在香港申請。</li>
<li style="margin-bottom: 8px;">The information provided in this Application Form is in all respects complete, true and accurate, and I should provide supporting documents and other information as required by Hong Kong Trust Capital Management Limited (“HKTCM”). I shall bear the legal responsibility for the above information;<br>本人確認本申請表格上提供的所有資料均為完整、真實及準確，及同意隨時提供相關證明、文件及其他補充資料；如有不實之處，本人願意承擔由此導致的法律責任；</li>
<li style="margin-bottom: 8px;">I agree and authorize Hong Kong Trust Capital Management Limited to review the accuracy and authenticity of all information on this Application Form, and Hong Kong Trust Capital Management Limited shall have full power to accept the application.<br>本人同意及授權香港信託資產管理有限公司查詢、檢查及審核填寫在此申請表上的所有資料及申請事項，並同意香港信託資產管理有限公司持最終審批權；</li>
<li style="margin-bottom: 8px;">I have read, understood and agreed to be bound by all clauses of《Terms and Conditions》, charges, limits and Privacy Policy as issued by Hong Kong Trust Capital Management Limited.<br>本人已閱讀、明白及同意香港信託資產管理有限公司發佈並不時修改的《條款及細則》、限額、收費及私隱政策，並同意接受其約束。</li>
<li>I agree and understand that my personal data will be collected by my agent or Authorized Person of The Company for the purpose of opening a HKTCM Global VISA Prepaid Card.<br>本人同意及明白代理人或代辦公司會收集本人的個人資料用作開立HKTCM 環球VISA 預付卡。</li>
</ul>
</div>
<div style="display: flex; align-items: flex-start; gap: 20px; flex-wrap: wrap;">
<div style="flex: 1; min-width: 300px;">
<SignaturePad
ref="sigPad1"
v-model="formData.signatureData1"
title="Please sign above"
:width="500"
:height="200"
@input="handleSignatureUpdate(1, $event)"
/>
</div>
</div>
</div>
</div>

<!-- 添加附属卡按钮 -->
<div style="margin-bottom: 20px;">
<el-button type="text" @click="toggleCard2" style="color: var(--primary-color); padding: 0; height: auto; font-size: 14px;">
{{ formData.showCard2 ? '▲ Close supplementary card' : '➕ Add an additional card' }}
</el-button>
</div>

<!-- ============ 附属卡 1 ============ -->
<div v-if="formData.showCard2" style="margin-bottom: 25px; padding: 16px; background: #fafafa; border-radius: 8px;">
<div style="font-weight: bold; margin-bottom: 15px; font-size: 15px; color: var(--primary-color);">📇 Supplementary Card 1 - Cardholder Information</div>
<!-- 基本信息 -->
<div class="form-group-title">Basic Identity Information</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Cardholder Name (Chinese)<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.cardName2Chinese" placeholder="Please enter Chinese name" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">Cardholder Name (English)<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.cardName2" @input="handleCardName2Input" placeholder="Please enter English name only" class="form-input required-input"></el-input>
<span class="char-counter" :class="getCharCountClass(formData.cardName2 ? formData.cardName2.length : 0)" style="font-size: 11px; color: #666;">{{ formData.cardName2 ? formData.cardName2.length : 0 }}/20</span>
</div>
<div class="form-group">
<label class="form-label">Gender<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.gender2" placeholder="Please select" class="form-input required-input">
<el-option label="Male" value="male"></el-option>
<el-option label="Female" value="female"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Nationality<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.nationality2" filterable placeholder="Please select" class="form-input required-input">
<el-option v-for="country in countryList" :key="country.code" :label="country.name" :value="country.name" />
</el-select>
</div>
</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Date of Birth<span style="color: #EF4444;">*</span></label>
<el-date-picker v-model="formData.dateOfBirth2" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
<div class="form-group">
<label class="form-label">ID Type<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.idType2" placeholder="Select ID Type" class="form-input required-input" @change="handleIdTypeChange2">
<el-option label="Mainland Resident Permit" value="MainlandID"></el-option>
<el-option label="Hong Kong Identity Card" value="HKID"></el-option>
<el-option label="Passport" value="Passport"></el-option>
<el-option label="Other" value="Other"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">ID Number<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.idNumber2" placeholder="ID or Passport Number" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">ID Issue Date<span style="color: #EF4444;">*</span></label>
<el-date-picker v-model="formData.idIssueDate2" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">ID Expiry Date<span style="color: #EF4444;">*</span></label>
<el-date-picker v-model="formData.idExpiryDate2" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
<div class="form-group" style="grid-column: span 3;">
<label class="form-label">ID Card Address<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.idAddress2" type="textarea" :rows="2" placeholder="Address as shown on ID document" class="form-input required-input"></el-input>
</div>
</div>
<!-- 证件上传 -->
<div class="form-group-title" style="margin-top: 20px;">ID Document Upload<span style="color: #EF4444;">*</span></div>
<div style="margin-top: 15px; padding: 15px; background: #f0f0f0; border-radius: 6px;">
<div class="part-a-grid">
<div v-if="formData.idType2 === 'MainlandID'" class="form-group">
<label class="form-label">ID Front (Portrait) <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocFrontFileList2" :on-change="(file) => handleIdUpload(file, 'idDocFrontUrl2', 'idDocFrontFileList2')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf">
<el-button size="small" type="primary">Upload Front</el-button>
</el-upload>
<div v-if="formData.idDocFrontFileList2.length > 0" style="font-size: 11px; color: #10b981; margin-top: 3px;">✓ Uploaded</div>
</div>
<div v-if="formData.idType2 === 'MainlandID'" class="form-group">
<label class="form-label">ID Back (Emblem)<span style="color: #EF4444;">*</span> <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocBackFileList2" :on-change="(file) => handleIdUpload(file, 'idDocBackUrl2', 'idDocBackFileList2')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf">
<el-button size="small" type="primary">Upload Back</el-button>
</el-upload>
<div v-if="formData.idDocBackFileList2.length > 0" style="font-size: 11px; color: #10b981; margin-top: 3px;">✓ Uploaded</div>
</div>
<div v-if="formData.idType2 === 'HKID' || formData.idType2 === 'Passport' || formData.idType2 === 'Other'" class="form-group">
<label class="form-label">ID Information Page<span style="color: #EF4444;">*</span> <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocInfoFileList2" :on-change="(file) => handleIdUpload(file, 'idDocInfoUrl2', 'idDocInfoFileList2')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf">
<el-button size="small" type="primary">Upload ID Page</el-button>
</el-upload>
<div v-if="formData.idDocInfoFileList2.length > 0" style="font-size: 11px; color: #10b981; margin-top: 3px;">✓ Uploaded</div>
</div>
</div>
</div>
<!-- 联系信息 -->
<div class="form-group-title" style="margin-top: 20px;">Contact Information</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Telephone<span style="color: #EF4444;">*</span></label>
<div style="display:flex; gap:8px;">
<el-select v-model="formData.phoneCode2" filterable placeholder="Code" style="width: 240px;" class="form-input">
<el-option label="+852 HK" value="+852" />
<el-option label="+86 CN" value="+86" />
<el-option label="+853 MO" value="+853" />
<el-option label="+886 TW" value="+886" />
<el-option label="+65 SG" value="+65" />
<el-option label="+60 MY" value="+60" />
<el-option label="+971 AE" value="+971" />
<el-option label="+82 KR" value="+82" />
<el-option label="+81 JP" value="+81" />
<el-option label="+66 TH" value="+66" />
<el-option label="+1 US/CA" value="+1" />
<el-option label="+44 UK" value="+44" />
<el-option label="+61 AU" value="+61" />
</el-select>
<el-input v-model="formData.phone2" @input="handlePhoneInput(2, $event.target.value)" placeholder="Phone number" class="form-input required-input"></el-input>
</div>
</div>
<div class="form-group">
<label class="form-label">Email address<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.email2" placeholder="Email address" type="email" class="form-input required-input"></el-input>
</div>
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Postal Address<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.address2" type="textarea" :rows="2" placeholder="Full postal address" class="form-input required-input"></el-input>
</div>
</div>
<!-- 职业与合规 -->
<div class="form-group-title" style="margin-top: 20px;">Professional & Compliance Information</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Occupation Type<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.occupation2" placeholder="Select Occupation" class="form-input required-input">
<el-option v-for="opt in industryOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Position<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.jobTitle2" placeholder="Select Position" class="form-input required-input">
<el-option v-for="opt in positionOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Years of Service<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.yearsOfService2" placeholder="e.g. 5 years" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">Yearly Income<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.yearlyIncome2" placeholder="e.g. 500000" class="form-input required-input"></el-input>
</div>
</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Company Name<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.companyName2" placeholder="Please enter company name" class="form-input required-input"></el-input>
</div>
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Office Address<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.officeAddress2" type="textarea" :rows="2" placeholder="Please enter office address" class="form-input required-input"></el-input>
</div>
</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group">
<label class="form-label">Office Tel. No.<span style="color: #EF4444;">*</span></label>
<div style="display:flex; gap:8px;">
<el-select v-model="formData.officeTelCode2" filterable placeholder="Code" style="width: 240px;" class="form-input">
<el-option label="+852 HK" value="+852" />
<el-option label="+86 CN" value="+86" />
<el-option label="+853 MO" value="+853" />
<el-option label="+886 TW" value="+886" />
<el-option label="+65 SG" value="+65" />
<el-option label="+60 MY" value="+60" />
<el-option label="+971 AE" value="+971" />
<el-option label="+82 KR" value="+82" />
<el-option label="+81 JP" value="+81" />
<el-option label="+66 TH" value="+66" />
<el-option label="+1 US/CA" value="+1" />
<el-option label="+44 UK" value="+44" />
<el-option label="+61 AU" value="+61" />
</el-select>
<el-input v-model="formData.officeTel2" placeholder="Office number" class="form-input required-input"></el-input>
</div>
</div>
<div class="form-group">
<label class="form-label">Purpose of Account<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.accountPurpose2" placeholder="Select Purpose" class="form-input required-input" @change="handlePurposeChange2">
<el-option v-for="opt in purposeOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Source of Wealth<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.sourceOfWealth2" placeholder="Select Source" class="form-input required-input" @change="handleWealthChange2">
<el-option v-for="opt in wealthOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group" v-if="formData.sourceOfWealth2 === '07'">
<label class="form-label">Source of Wealth (Please note)<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.sourceOfWealthOther2" placeholder="Please specify" class="form-input required-input"></el-input>
</div>
</div>
<!-- 卡片设置 -->
<div class="form-group-title" style="margin-top: 20px;">Card Settings<span style="color: #EF4444;">*</span></div>
<div style="display: flex; align-items: center; gap: 16px; margin-top: 15px; margin-left: 0;">
<span>Application Category:</span>
<template v-for="option in availableCardTypes">
<label :key="`2-${option.value}`" style="display: flex; align-items: center; gap: 4px; cursor: pointer;" v-if="option.visible">
<input type="radio" v-model="formData.cardType2" :value="option.value" :name="'cardType2'"> {{ option.label }}
</label>
</template>
</div>
<div v-if="formData.cardType2" class="card-preview" style="margin-top: 15px;">
<img :src="getCardImage(formData.cardType2, formData.showLogoOnCard2)" alt="Prepaid Card Preview"/>
<div v-if="formData.showNameOnCard2" class="name-overlay" :style="{ color: formData.cardType2 === 'black' ? '#d6c6a4' : '#ffffff' }">{{ formData.cardName2 || 'Contact Information' }}</div>
</div>
<div v-if="formData.cardType2" style="margin-top: 10px; display: flex; gap: 20px; font-size: 13px; color: var(--text-secondary);">
<label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
<input type="checkbox" v-model="formData.showNameOnCard2"> Display Cardholder's Name
</label>
<label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
<input type="checkbox" v-model="formData.showLogoOnCard2"> Display Company Logo
</label>
</div>
<!-- ✅ 附属卡 1 电子签名 - 使用 SignaturePad 组件 -->
<div class="signature-section" style="margin-top: 30px; padding: 20px; background: #f8f9fa; border-radius: 8px; border: 1px solid #e2e8f0;">
<div class="form-group-title" style="margin-top: 0;">Electronic Signature - Supplementary Cardholder 1<span style="color: #EF4444;">*</span></div>
<div class="declaration-text" style="margin: 15px 0; padding: 15px; background: #fff; border: 1px solid #ddd; border-radius: 4px; font-size: 13px; line-height: 1.6; max-height: 200px; overflow-y: auto;">
<p style="margin-bottom: 10px;"><strong>I (The Applicant) hereby declare that after signing in the signature column herein below by myself (the Applicant), indicated that I have already fully read, understood, agreed, confirmed and accepted:</strong><br>
<strong>本人 (申請人) 謹此聲明，當本人於下列簽署欄內簽署後，即表示本人已細閱、同意、明白、確認及遵守以下各項聲明：</strong></p>
<ul style="padding-left: 20px; margin: 0;">
<li style="margin-bottom: 8px;">Applicant must apply HKTCM Global VISA Prepaid Card in Hong Kong and aged 18 or above. HKTCM 環球VISA 預付卡申請人須為年滿 18 歲及在香港申請。</li>
<li style="margin-bottom: 8px;">The information provided in this Application Form is in all respects complete, true and accurate, and I should provide supporting documents and other information as required by Hong Kong Trust Capital Management Limited (“HKTCM”). I shall bear the legal responsibility for the above information;<br>本人確認本申請表格上提供的所有資料均為完整、真實及準確，及同意隨時提供相關證明、文件及其他補充資料；如有不實之處，本人願意承擔由此導致的法律責任；</li>
<li style="margin-bottom: 8px;">I agree and authorize Hong Kong Trust Capital Management Limited to review the accuracy and authenticity of all information on this Application Form, and Hong Kong Trust Capital Management Limited shall have full power to accept the application.<br>本人同意及授權香港信託資產管理有限公司查詢、檢查及審核填寫在此申請表上的所有資料及申請事項，並同意香港信託資產管理有限公司持最終審批權；</li>
<li style="margin-bottom: 8px;">I have read, understood and agreed to be bound by all clauses of《Terms and Conditions》, charges, limits and Privacy Policy as issued by Hong Kong Trust Capital Management Limited.<br>本人已閱讀、明白及同意香港信託資產管理有限公司發佈並不時修改的《條款及細則》、限額、收費及私隱政策，並同意接受其約束。</li>
<li>I agree and understand that my personal data will be collected by my agent or Authorized Person of The Company for the purpose of opening a HKTCM Global VISA Prepaid Card.<br>本人同意及明白代理人或代辦公司會收集本人的個人資料用作開立HKTCM 環球VISA 預付卡。</li>
</ul>
</div>
<div style="display: flex; align-items: flex-start; gap: 20px; flex-wrap: wrap;">
<div style="flex: 1; min-width: 300px;">
<SignaturePad
ref="sigPad2"
v-model="formData.signatureData2"
title="Please sign above"
:width="500"
:height="200"
@input="handleSignatureUpdate(2, $event)"
/>
</div>
<div style="display: flex; flex-direction: column; gap: 10px;">
<el-button size="small" @click="clearSignature(2)" type="warning">Clear Signature</el-button>
<div v-if="formData.isSigned2" style="font-size: 12px; color: #10b981; text-align: center;">✓ Signed</div>
</div>
</div>
</div>
<!-- 附属卡 1 额度设置 -->
<div class="form-group-title" style="margin-top: 20px;">💳 Credit Limit Setting</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Credit Limit (HKD) <span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.creditLimit2" placeholder="e.g. 50000" class="form-input required-input"></el-input>
</div>
</div>
</div>

<!-- 添加第二张附属卡 -->
<div v-if="formData.showCard2" style="margin-bottom: 20px;">
<el-button type="text" @click="toggleCard3" style="color: var(--primary-color); padding: 0; height: auto; font-size: 14px;">
{{ formData.showCard3 ? '▲ Retract the second supplementary card' : '➕ Add a second supplementary card' }}
</el-button>
</div>

<!-- ============ 附属卡 2 ============ -->
<div v-if="formData.showCard3" style="margin-bottom: 25px; padding: 16px; background: #fafafa; border-radius: 8px;">
<div style="font-weight: bold; margin-bottom: 15px; font-size: 15px; color: var(--primary-color);">📇 Supplementary Card 2 - Cardholder Information</div>
<!-- 基本信息 -->
<div class="form-group-title">Basic Identity Information</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Cardholder Name (Chinese)<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.cardName3Chinese" placeholder="Please enter Chinese name" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">Cardholder Name (English)<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.cardName3" @input="handleCardName3Input" placeholder="Please enter English name only" class="form-input required-input"></el-input>
<span class="char-counter" :class="getCharCountClass(formData.cardName3 ? formData.cardName3.length : 0)" style="font-size: 11px; color: #666;">{{ formData.cardName3 ? formData.cardName3.length : 0 }}/20</span>
</div>
<div class="form-group">
<label class="form-label">Gender<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.gender3" placeholder="Please select" class="form-input required-input">
<el-option label="Male" value="male"></el-option>
<el-option label="Female" value="female"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Nationality<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.nationality3" filterable placeholder="Please select" class="form-input required-input">
<el-option v-for="country in countryList" :key="country.code" :label="country.name" :value="country.name" />
</el-select>
</div>
</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Date of Birth<span style="color: #EF4444;">*</span></label>
<el-date-picker v-model="formData.dateOfBirth3" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
<div class="form-group">
<label class="form-label">ID Type<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.idType3" placeholder="Select ID Type" class="form-input required-input" @change="handleIdTypeChange3">
<el-option label="Mainland Resident Permit" value="MainlandID"></el-option>
<el-option label="Hong Kong Identity Card" value="HKID"></el-option>
<el-option label="Passport" value="Passport"></el-option>
<el-option label="Other" value="Other"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">ID Number<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.idNumber3" placeholder="ID or Passport Number" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">ID Issue Date<span style="color: #EF4444;">*</span></label>
<el-date-picker v-model="formData.idIssueDate3" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">ID Expiry Date<span style="color: #EF4444;">*</span></label>
<el-date-picker v-model="formData.idExpiryDate3" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
<div class="form-group" style="grid-column: span 3;">
<label class="form-label">ID Card Address<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.idAddress3" type="textarea" :rows="2" placeholder="Address as shown on ID document" class="form-input required-input"></el-input>
</div>
</div>
<!-- 证件上传 -->
<div class="form-group-title" style="margin-top: 20px;">ID Document Upload<span style="color: #EF4444;">*</span></div>
<div style="margin-top: 15px; padding: 15px; background: #f0f0f0; border-radius: 6px;">
<div class="part-a-grid">
<div v-if="formData.idType3 === 'MainlandID'" class="form-group">
<label class="form-label">ID Front (Portrait) <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocFrontFileList3" :on-change="(file) => handleIdUpload(file, 'idDocFrontUrl3', 'idDocFrontFileList3')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf">
<el-button size="small" type="primary">Upload Front</el-button>
</el-upload>
<div v-if="formData.idDocFrontFileList3.length > 0" style="font-size: 11px; color: #10b981; margin-top: 3px;">✓ Uploaded</div>
</div>
<div v-if="formData.idType3 === 'MainlandID'" class="form-group">
<label class="form-label">ID Back (Emblem) <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocBackFileList3" :on-change="(file) => handleIdUpload(file, 'idDocBackUrl3', 'idDocBackFileList3')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf">
<el-button size="small" type="primary">Upload Back</el-button>
</el-upload>
<div v-if="formData.idDocBackFileList3.length > 0" style="font-size: 11px; color: #10b981; margin-top: 3px;">✓ Uploaded</div>
</div>
<div v-if="formData.idType3 === 'HKID' || formData.idType3 === 'Passport' || formData.idType3 === 'Other'" class="form-group">
<label class="form-label">ID Information Page <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocInfoFileList3" :on-change="(file) => handleIdUpload(file, 'idDocInfoUrl3', 'idDocInfoFileList3')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf">
<el-button size="small" type="primary">Upload ID Page</el-button>
</el-upload>
<div v-if="formData.idDocInfoFileList3.length > 0" style="font-size: 11px; color: #10b981; margin-top: 3px;">✓ Uploaded</div>
</div>
</div>
</div>
<!-- 联系信息 -->
<div class="form-group-title" style="margin-top: 20px;">Contact Information</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Telephone<span style="color: #EF4444;">*</span></label>
<div style="display:flex; gap:8px;">
<el-select v-model="formData.phoneCode3" filterable placeholder="Code" style="width: 240px;" class="form-input">
<el-option label="+852 HK" value="+852" />
<el-option label="+86 CN" value="+86" />
<el-option label="+853 MO" value="+853" />
<el-option label="+886 TW" value="+886" />
<el-option label="+65 SG" value="+65" />
<el-option label="+60 MY" value="+60" />
<el-option label="+971 AE" value="+971" />
<el-option label="+82 KR" value="+82" />
<el-option label="+81 JP" value="+81" />
<el-option label="+66 TH" value="+66" />
<el-option label="+1 US/CA" value="+1" />
<el-option label="+44 UK" value="+44" />
<el-option label="+61 AU" value="+61" />
</el-select>
<el-input v-model="formData.phone3" @input="handlePhoneInput(3, $event.target.value)" placeholder="Phone number" class="form-input required-input"></el-input>
</div>
</div>
<div class="form-group">
<label class="form-label">Email address<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.email3" placeholder="Email address" type="email" class="form-input required-input"></el-input>
</div>
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Postal Address<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.address3" type="textarea" :rows="2" placeholder="Full postal address" class="form-input required-input"></el-input>
</div>
</div>
<!-- 职业与合规 -->
<div class="form-group-title" style="margin-top: 20px;">Professional & Compliance Information</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Occupation Type<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.occupation3" placeholder="Select Occupation" class="form-input required-input">
<el-option v-for="opt in industryOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Position<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.jobTitle3" placeholder="Select Position" class="form-input required-input">
<el-option v-for="opt in positionOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Years of Service<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.yearsOfService3" placeholder="e.g. 5 years" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">Yearly Income<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.yearlyIncome3" placeholder="e.g. 500000" class="form-input required-input"></el-input>
</div>
</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Company Name<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.companyName3" placeholder="Please enter company name" class="form-input required-input"></el-input>
</div>
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Office Address<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.officeAddress3" type="textarea" :rows="2" placeholder="Please enter office address" class="form-input required-input"></el-input>
</div>
</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group">
<label class="form-label">Office Tel. No.<span style="color: #EF4444;">*</span></label>
<div style="display:flex; gap:8px;">
<el-select v-model="formData.officeTelCode3" filterable placeholder="Code" style="width: 240px;" class="form-input">
<el-option label="+852 HK" value="+852" />
<el-option label="+86 CN" value="+86" />
<el-option label="+853 MO" value="+853" />
<el-option label="+886 TW" value="+886" />
<el-option label="+65 SG" value="+65" />
<el-option label="+60 MY" value="+60" />
<el-option label="+971 AE" value="+971" />
<el-option label="+82 KR" value="+82" />
<el-option label="+81 JP" value="+81" />
<el-option label="+66 TH" value="+66" />
<el-option label="+1 US/CA" value="+1" />
<el-option label="+44 UK" value="+44" />
<el-option label="+61 AU" value="+61" />
</el-select>
<el-input v-model="formData.officeTel3" placeholder="Office number" class="form-input required-input"></el-input>
</div>
</div>
<div class="form-group">
<label class="form-label">Purpose of Account<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.accountPurpose3" placeholder="Select Purpose" class="form-input required-input" @change="handlePurposeChange3">
<el-option v-for="opt in purposeOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Source of Wealth<span style="color: #EF4444;">*</span></label>
<el-select v-model="formData.sourceOfWealth3" placeholder="Select Source" class="form-input required-input" @change="handleWealthChange3">
<el-option v-for="opt in wealthOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group" v-if="formData.sourceOfWealth3 === '07'">
<label class="form-label">Source of Wealth (Please note)<span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.sourceOfWealthOther3" placeholder="Please specify" class="form-input required-input"></el-input>
</div>
</div>
<!-- 卡片设置 -->
<div class="form-group-title" style="margin-top: 20px;">Card Settings<span style="color: #EF4444;">*</span></div>
<div style="display: flex; align-items: center; gap: 16px; margin-top: 15px; margin-left: 0;">
<span>Application Category:</span>
<template v-for="option in availableCardTypes">
<label :key="`3-${option.value}`" style="display: flex; align-items: center; gap: 4px; cursor: pointer;" v-if="option.visible">
<input type="radio" v-model="formData.cardType3" :value="option.value" :name="'cardType3'"> {{ option.label }}
</label>
</template>
</div>
<div v-if="formData.cardType3" class="card-preview" style="margin-top: 15px;">
<img :src="getCardImage(formData.cardType3, formData.showLogoOnCard3)" alt="Prepaid Card Preview"/>
<div v-if="formData.showNameOnCard3" class="name-overlay" :style="{ color: formData.cardType3 === 'black' ? '#d6c6a4' : '#ffffff' }">{{ formData.cardName3 || 'Contact Information' }}</div>
</div>
<div v-if="formData.cardType3" style="margin-top: 10px; display: flex; gap: 20px; font-size: 13px; color: var(--text-secondary);">
<label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
<input type="checkbox" v-model="formData.showNameOnCard3"> Display Cardholder's Name
</label>
<label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
<input type="checkbox" v-model="formData.showLogoOnCard3"> Display Company Logo
</label>
</div>
<!-- ✅ 附属卡 2 电子签名 - 使用 SignaturePad 组件 -->
<div class="signature-section" style="margin-top: 30px; padding: 20px; background: #f8f9fa; border-radius: 8px; border: 1px solid #e2e8f0;">
<div class="form-group-title" style="margin-top: 0;">Electronic Signature - Supplementary Cardholder 2<span style="color: #EF4444;">*</span></div>
<div class="declaration-text" style="margin: 15px 0; padding: 15px; background: #fff; border: 1px solid #ddd; border-radius: 4px; font-size: 13px; line-height: 1.6; max-height: 200px; overflow-y: auto;">
<p style="margin-bottom: 10px;"><strong>I (The Applicant) hereby declare that after signing in the signature column herein below by myself (the Applicant), indicated that I have already fully read, understood, agreed, confirmed and accepted:</strong><br>
<strong>本人 (申請人) 謹此聲明，當本人於下列簽署欄內簽署後，即表示本人已細閱、同意、明白、確認及遵守以下各項聲明：</strong></p>
<ul style="padding-left: 20px; margin: 0;">
<li style="margin-bottom: 8px;">Applicant must apply HKTCM Global VISA Prepaid Card in Hong Kong and aged 18 or above. HKTCM 環球VISA 預付卡申請人須為年滿 18 歲及在香港申請。</li>
<li style="margin-bottom: 8px;">The information provided in this Application Form is in all respects complete, true and accurate, and I should provide supporting documents and other information as required by Hong Kong Trust Capital Management Limited (“HKTCM”). I shall bear the legal responsibility for the above information;<br>本人確認本申請表格上提供的所有資料均為完整、真實及準確，及同意隨時提供相關證明、文件及其他補充資料；如有不實之處，本人願意承擔由此導致的法律責任；</li>
<li style="margin-bottom: 8px;">I agree and authorize Hong Kong Trust Capital Management Limited to review the accuracy and authenticity of all information on this Application Form, and Hong Kong Trust Capital Management Limited shall have full power to accept the application.<br>本人同意及授權香港信託資產管理有限公司查詢、檢查及審核填寫在此申請表上的所有資料及申請事項，並同意香港信託資產管理有限公司持最終審批權；</li>
<li style="margin-bottom: 8px;">I have read, understood and agreed to be bound by all clauses of《Terms and Conditions》, charges, limits and Privacy Policy as issued by Hong Kong Trust Capital Management Limited.<br>本人已閱讀、明白及同意香港信託資產管理有限公司發佈並不時修改的《條款及細則》、限額、收費及私隱政策，並同意接受其約束。</li>
<li>I agree and understand that my personal data will be collected by my agent or Authorized Person of The Company for the purpose of opening a HKTCM Global VISA Prepaid Card.<br>本人同意及明白代理人或代辦公司會收集本人的個人資料用作開立HKTCM 環球VISA 預付卡。</li>
</ul>
</div>
<div style="display: flex; align-items: flex-start; gap: 20px; flex-wrap: wrap;">
<div style="flex: 1; min-width: 300px;">
<SignaturePad
ref="sigPad3"
v-model="formData.signatureData3"
title="Please sign above"
:width="500"
:height="200"
@input="handleSignatureUpdate(3, $event)"
/>
</div>
<div style="display: flex; flex-direction: column; gap: 10px;">
<el-button size="small" @click="clearSignature(3)" type="warning">Clear Signature</el-button>
<div v-if="formData.isSigned3" style="font-size: 12px; color: #10b981; text-align: center;">✓ Signed</div>
</div>
</div>
</div>
<!-- 附属卡 2 额度设置 -->
<div class="form-group-title" style="margin-top: 20px;">💳 Credit Limit Setting</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Credit Limit (HKD) <span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.creditLimit3" placeholder="e.g. 50000" class="form-input required-input"></el-input>
</div>
</div>
</div>
</div>

<div class="form-footer" slot="footer">
<el-button v-if="currentStep > 1" @click="prevStep" class="form-btn btn-prev">Previous step</el-button>
<el-button v-if="currentStep < 2" @click="nextStep" class="form-btn btn-next">Next step</el-button>
<el-button v-if="currentStep === 2" type="primary" @click="submitApplication" class="form-btn btn-submit">Submit an application</el-button>
</div>
</el-dialog>

<!-- 预览确认弹窗 -->
<el-dialog :visible.sync="previewVisible" title="Application Information Preview" width="1000px" :append-to-body="true">
<div v-if="previewData" class="preview-content">
<h3 style="text-align: center; margin-bottom: 20px;">HKTCM Prepaid Card Application Form</h3>
<h4 class="section-title">Applicant Information</h4>
<table class="preview-table">
<tr><th>Application No.:</th><td>{{ previewData.busiWaterNo || 'N/A' }}</td></tr>
<tr><th>Trust account number:</th><td>{{ previewData.username || 'N/A' }}</td></tr>
<tr><th>Name:</th><td>{{ previewData.Name }}</td></tr>
<tr><th>English Name:</th><td>{{ previewData.englishName || 'N/A' }}</td></tr>
<tr><th>Gender:</th><td>{{ previewData.gender }}</td></tr>
<tr><th>Nationality:</th><td>{{ previewData.nationality || 'N/A' }}</td></tr>
<tr><th>Date of Birth:</th><td>{{ previewData.dateOfBirth || 'N/A' }}</td></tr>
<tr><th>ID Type:</th><td>{{ previewData.idType || 'N/A' }}</td></tr>
<tr><th>ID Number:</th><td>{{ previewData.idNumber || 'N/A' }}</td></tr>
<tr><th>ID Issue Date:</th><td>{{ previewData.idIssueDate || 'N/A' }}</td></tr>
<tr><th>ID Expiry Date:</th><td>{{ previewData.idExpiryDate || 'N/A' }}</td></tr>
<tr><th>ID Address:</th><td>{{ previewData.idAddress || 'N/A' }}</td></tr>
<tr><th>ID Documents:</th><td>
<span v-if="previewData.idType === 'MainlandID'">Front: {{ previewData.idDocFrontFileList?.length > 0 ? '✓' : '✗' }} | Back: {{ previewData.idDocBackFileList?.length > 0 ? '✓' : '✗' }}</span>
<span v-else>Info Page: {{ previewData.idDocInfoFileList?.length > 0 ? '✓' : '✗' }}</span>
</td></tr>
<tr><th>Telephone:</th><td>{{ previewData.phoneCode }} {{ previewData.phone || 'N/A' }}</td></tr>
<tr><th>Email address:</th><td>{{ previewData.email || 'N/A' }}</td></tr>
<tr><th>Postal Address:</th><td>{{ previewData.address || 'N/A' }}</td></tr>
<tr><th>Occupation:</th><td>{{ previewData.occupation || 'N/A' }}</td></tr>
<tr><th>Position:</th><td>{{ previewData.jobTitle || 'N/A' }}</td></tr>
<tr><th>Years of Service:</th><td>{{ previewData.yearsOfService || 'N/A' }}</td></tr>
<tr><th>Yearly Income:</th><td>{{ previewData.yearlyIncome || 'N/A' }}</td></tr>
<tr><th>Company Name:</th><td>{{ previewData.companyName || 'N/A' }}</td></tr>
<tr><th>Office Address:</th><td>{{ previewData.officeAddress || 'N/A' }}</td></tr>
<tr><th>Office Tel:</th><td>{{ previewData.officeTelCode }} {{ previewData.officeTel || 'N/A' }}</td></tr>
<tr><th>Account Purpose:</th><td>{{ previewData.accountPurpose || 'N/A' }}</td></tr>
<tr><th>Source of Wealth:</th><td>{{ previewData.sourceOfWealth || 'N/A' }} {{ previewData.sourceOfWealthOther ? '(' + previewData.sourceOfWealthOther + ')' : '' }}</td></tr>
<tr><th>Signature Status:</th><td>{{ previewData.isSigned1 ? '✓ Signed' : '✗ Not Signed' }}</td></tr>
</table>
<h4 class="section-title">Primary Card Information</h4>
<table class="preview-table">
<tr><th>Cardholder Name:</th><td>{{ previewData.cardName1 || 'N/A' }}</td></tr>
<tr><th>Card Type:</th><td>{{ previewData.cardType1 ? cardTypeLabels[previewData.cardType1] : 'N/A' }}</td></tr>
<tr><th>Display Name:</th><td>{{ boolToText(previewData.showNameOnCard1) }}</td></tr>
<tr><th>Display Logo:</th><td>{{ boolToText(previewData.showLogoOnCard1) }}</td></tr>
</table>
<template v-if="previewData.cardName2 && previewData.cardName2.trim()">
<h4 class="section-title">Supplementary Card 1 Information</h4>
<table class="preview-table">
<tr><th>Cardholder Name (Chinese):</th><td>{{ previewData.cardName2Chinese || 'N/A' }}</td></tr>
<tr><th>Cardholder Name (English):</th><td>{{ previewData.cardName2 }}</td></tr>
<tr><th>Gender:</th><td>{{ previewData.gender2 || 'N/A' }}</td></tr>
<tr><th>Nationality:</th><td>{{ previewData.nationality2 || 'N/A' }}</td></tr>
<tr><th>Date of Birth:</th><td>{{ previewData.dateOfBirth2 || 'N/A' }}</td></tr>
<tr><th>ID Type:</th><td>{{ previewData.idType2 || 'N/A' }}</td></tr>
<tr><th>ID Number:</th><td>{{ previewData.idNumber2 || 'N/A' }}</td></tr>
<tr><th>ID Issue Date:</th><td>{{ previewData.idIssueDate2 || 'N/A' }}</td></tr>
<tr><th>ID Expiry Date:</th><td>{{ previewData.idExpiryDate2 || 'N/A' }}</td></tr>
<tr><th>ID Address:</th><td>{{ previewData.idAddress2 || 'N/A' }}</td></tr>
<tr><th>ID Documents:</th><td>
<span v-if="previewData.idType2 === 'MainlandID'">Front: {{ previewData.idDocFrontFileList2?.length > 0 ? '✓' : '✗' }} | Back: {{ previewData.idDocBackFileList2?.length > 0 ? '✓' : '✗' }}</span>
<span v-else>Info Page: {{ previewData.idDocInfoFileList2?.length > 0 ? '✓' : '✗' }}</span>
</td></tr>
<tr><th>Telephone:</th><td>{{ previewData.phoneCode2 }} {{ previewData.phone2 || 'N/A' }}</td></tr>
<tr><th>Email:</th><td>{{ previewData.email2 || 'N/A' }}</td></tr>
<tr><th>Address:</th><td>{{ previewData.address2 || 'N/A' }}</td></tr>
<tr><th>Occupation:</th><td>{{ previewData.occupation2 || 'N/A' }}</td></tr>
<tr><th>Position:</th><td>{{ previewData.jobTitle2 || 'N/A' }}</td></tr>
<tr><th>Years of Service:</th><td>{{ previewData.yearsOfService2 || 'N/A' }}</td></tr>
<tr><th>Yearly Income:</th><td>{{ previewData.yearlyIncome2 || 'N/A' }}</td></tr>
<tr><th>Company Name:</th><td>{{ previewData.companyName2 || 'N/A' }}</td></tr>
<tr><th>Office Address:</th><td>{{ previewData.officeAddress2 || 'N/A' }}</td></tr>
<tr><th>Office Tel:</th><td>{{ previewData.officeTelCode2 }} {{ previewData.officeTel2 || 'N/A' }}</td></tr>
<tr><th>Account Purpose:</th><td>{{ previewData.accountPurpose2 || 'N/A' }}</td></tr>
<tr><th>Source of Wealth:</th><td>{{ previewData.sourceOfWealth2 || 'N/A' }} {{ previewData.sourceOfWealthOther2 ? '(' + previewData.sourceOfWealthOther2 + ')' : '' }}</td></tr>
<tr><th>Card Type:</th><td>{{ previewData.cardType2 ? cardTypeLabels[previewData.cardType2] : 'N/A' }}</td></tr>
<tr><th>Display Name:</th><td>{{ boolToText(previewData.showNameOnCard2) }}</td></tr>
<tr><th>Display Logo:</th><td>{{ boolToText(previewData.showLogoOnCard2) }}</td></tr>
<tr><th>Credit Limit:</th><td>{{ previewData.creditLimit2 || 'N/A' }}</td></tr>
<tr><th>Signature Status:</th><td>{{ previewData.isSigned2 ? '✓ Signed' : '✗ Not Signed' }}</td></tr>
</table>
</template>
<template v-if="previewData.cardName3 && previewData.cardName3.trim()">
<h4 class="section-title">Supplementary Card 2 Information</h4>
<table class="preview-table">
<tr><th>Cardholder Name (Chinese):</th><td>{{ previewData.cardName3Chinese || 'N/A' }}</td></tr>
<tr><th>Cardholder Name (English):</th><td>{{ previewData.cardName3 }}</td></tr>
<tr><th>Gender:</th><td>{{ previewData.gender3 || 'N/A' }}</td></tr>
<tr><th>Nationality:</th><td>{{ previewData.nationality3 || 'N/A' }}</td></tr>
<tr><th>Date of Birth:</th><td>{{ previewData.dateOfBirth3 || 'N/A' }}</td></tr>
<tr><th>ID Type:</th><td>{{ previewData.idType3 || 'N/A' }}</td></tr>
<tr><th>ID Number:</th><td>{{ previewData.idNumber3 || 'N/A' }}</td></tr>
<tr><th>ID Issue Date:</th><td>{{ previewData.idIssueDate3 || 'N/A' }}</td></tr>
<tr><th>ID Expiry Date:</th><td>{{ previewData.idExpiryDate3 || 'N/A' }}</td></tr>
<tr><th>ID Address:</th><td>{{ previewData.idAddress3 || 'N/A' }}</td></tr>
<tr><th>ID Documents:</th><td>
<span v-if="previewData.idType3 === 'MainlandID'">Front: {{ previewData.idDocFrontFileList3?.length > 0 ? '✓' : '✗' }} | Back: {{ previewData.idDocBackFileList3?.length > 0 ? '✓' : '✗' }}</span>
<span v-else>Info Page: {{ previewData.idDocInfoFileList3?.length > 0 ? '✓' : '✗' }}</span>
</td></tr>
<tr><th>Telephone:</th><td>{{ previewData.phoneCode3 }} {{ previewData.phone3 || 'N/A' }}</td></tr>
<tr><th>Email:</th><td>{{ previewData.email3 || 'N/A' }}</td></tr>
<tr><th>Address:</th><td>{{ previewData.address3 || 'N/A' }}</td></tr>
<tr><th>Occupation:</th><td>{{ previewData.occupation3 || 'N/A' }}</td></tr>
<tr><th>Position:</th><td>{{ previewData.jobTitle3 || 'N/A' }}</td></tr>
<tr><th>Years of Service:</th><td>{{ previewData.yearsOfService3 || 'N/A' }}</td></tr>
<tr><th>Yearly Income:</th><td>{{ previewData.yearlyIncome3 || 'N/A' }}</td></tr>
<tr><th>Company Name:</th><td>{{ previewData.companyName3 || 'N/A' }}</td></tr>
<tr><th>Office Address:</th><td>{{ previewData.officeAddress3 || 'N/A' }}</td></tr>
<tr><th>Office Tel:</th><td>{{ previewData.officeTelCode3 }} {{ previewData.officeTel3 || 'N/A' }}</td></tr>
<tr><th>Account Purpose:</th><td>{{ previewData.accountPurpose3 || 'N/A' }}</td></tr>
<tr><th>Source of Wealth:</th><td>{{ previewData.sourceOfWealth3 || 'N/A' }} {{ previewData.sourceOfWealthOther3 ? '(' + previewData.sourceOfWealthOther3 + ')' : '' }}</td></tr>
<tr><th>Card Type:</th><td>{{ previewData.cardType3 ? cardTypeLabels[previewData.cardType3] : 'N/A' }}</td></tr>
<tr><th>Display Name:</th><td>{{ boolToText(previewData.showNameOnCard3) }}</td></tr>
<tr><th>Display Logo:</th><td>{{ boolToText(previewData.showLogoOnCard3) }}</td></tr>
<tr><th>Credit Limit:</th><td>{{ previewData.creditLimit3 || 'N/A' }}</td></tr>
<tr><th>Signature Status:</th><td>{{ previewData.isSigned3 ? '✓ Signed' : '✗ Not Signed' }}</td></tr>
</table>
</template>
</div>
<div slot="footer" class="dialog-footer">
<el-button @click="previewVisible = false">Return to edit</el-button>
<el-button type="primary" @click="confirmAndSubmit">Confirm and submit</el-button>
</div>
</el-dialog>

<!-- 批核查询弹窗 -->
<el-dialog :visible.sync="queryVisible" title="Check the approval status" width="500px" class="query-dialog">
<el-form :model="queryForm" label-position="left" label-width="150px">
<el-form-item label="Methods:">
<el-radio-group v-model="queryForm.type">
<el-radio label="trust">Trust</el-radio>
<el-radio label="id">Document Number</el-radio>
</el-radio-group>
</el-form-item>
<el-form-item :label="queryForm.type === 'trust' ? 'Trust:' : 'Document:'">
<el-input v-model="queryForm.value" class="login-input"></el-input>
</el-form-item>
<el-form-item label="ImageCap:">
<div style="display: flex; align-items: center; gap: 10px;">
<el-input v-model="queryForm.captchaInput" placeholder="Enter code" style="width: 160px;"></el-input>
<canvas ref="captchaCanvas" width="100" height="40" style="border:1px solid #ddd; cursor:pointer;" @click="generateCaptcha"></canvas>
</div>
</el-form-item>
</el-form>
<div slot="footer" class="dialog-footer">
<el-button @click="queryVisible = false">Cancel</el-button>
<el-button type="primary" @click="handleQuery">Enquiry</el-button>
</div>
</el-dialog>

<!-- 批核详情页 -->
<el-dialog :visible.sync="detailVisible" title="Application Progress Details" width="700px" append-to-body>
<div v-if="currentApplication">
<div class="form-section">
<h3 class="section-title">Application Basic Information</h3>
<table class="preview-table">
<tr><th>Application Number</th><td>{{ currentApplication.appNo }}</td></tr>
<tr><th>Apply for the product</th><td>{{ currentApplication.product }}</td></tr>
<tr><th>Application period</th><td>{{ currentApplication.submitTime }}</td></tr>
</table>
</div>
<div class="form-section">
<h3 class="section-title">Application Progress</h3>
<el-steps :active="currentApplication.stepIndex" finish-status="success" simple>
<el-step title="Application submission" :description="currentApplication.submitTime"></el-step>
<el-step title="Data Verification" description="Expected completion within two working days"></el-step>
<el-step title="Credit rating" description="Internal risk control approval"></el-step>
<el-step title="Approval outcome" :description="getFinalStatusDesc(currentApplication.status)"></el-step>
</el-steps>
</div>
<div class="form-section">
<h3 class="section-title">Approval status</h3>
<p><strong>Current status:</strong><span :style="{ color: getStatusColor(currentApplication.status) }">{{ getStatusText(currentApplication.status) }}</span></p>
<div v-if="currentApplication.status === 'pending_docs'" style="background:#fff8e1; padding:12px; border-left:4px solid #F59E0B; margin-top:10px;">
<strong>⚠️ Reminder for supplementary documents:</strong>{{ currentApplication.missingDocs }}
</div>
<div v-if="currentApplication.status === 'approved' && currentApplication.trackingNumber" class="form-section">
<p><strong>Parcel tracking number:</strong>{{ currentApplication.trackingNumber }}
<a :href="currentApplication.trackingUrl" target="_blank" style="color: var(--primary-color); margin-left:10px;">View logistics</a></p>
</div>
</div>
<div v-if="currentApplication.status === 'approved'" class="form-section">
<h3 class="section-title">Card Configuration</h3>
<table class="preview-table">
<tr><th>Credit limit</th><td>{{ currentApplication.creditLimit }}</td></tr>
<tr><th>Statement date / Repayment date</th><td>{{ currentApplication.billingDay }} / {{ currentApplication.repaymentDay }}</td></tr>
</table>
<div v-if="currentApplication.subCards.length > 0" style="margin-top:15px;">
<h4 style="font-weight:bold; margin-bottom:8px;">List of Supplementary Cards</h4>
<div v-for="(sub, idx) in currentApplication.subCards" :key="idx" style="padding:10px; background:#f9fafb; border-radius:6px; margin-bottom:8px;">
<span>Cardholder:{{ sub.name }}｜Status:{{ sub.status === 'approved' ? 'Approved' : 'Not approved' }}</span>
</div>
</div>
</div>
</div>
<div slot="footer" class="dialog-footer">
<el-button @click="detailVisible = false">Close</el-button>
</div>
</el-dialog>
</div>

<!-- 加载状态 -->
<div v-if="loading" class="loading-overlay">
<div class="loading-content">
<el-spinner :size="50"></el-spinner>
<p>Verifying token...</p>
</div>
</div>
</div>
</template>

<script>
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css';
import {
Dialog, Form, FormItem, Input, Button, Select, Option, RadioGroup, Radio,
Upload, Steps, Step, Spinner, Loading, Message, DatePicker
} from 'element-ui';
// ✅ 导入 SignaturePad 组件
import SignaturePad from '@/views/SignaturePad.vue';

export default {
name: 'CreditCard',
components: {
[Dialog.name]: Dialog,
[Form.name]: Form,
[FormItem.name]: FormItem,
[Input.name]: Input,
[Button.name]: Button,
[Select.name]: Select,
[Option.name]: Option,
[RadioGroup.name]: RadioGroup,
[Radio.name]: Radio,
[Upload.name]: Upload,
[Steps.name]: Steps,
[Step.name]: Step,
[Spinner.name]: Spinner,
[DatePicker.name]: DatePicker,
// ✅ 注册 SignaturePad 组件
SignaturePad
},
data() {
return {
urlToken: '',
tokenValid: false,
loading: true,
adminCallbackUrl: '',
// 🔹 Country List - 3-digit ISO codes
countryList: [
{ code: 'CHN', name: 'China' }, { code: 'HKG', name: 'Hong Kong, China' }, { code: 'MAC', name: 'Macau, China' },
{ code: 'TWN', name: 'Taiwan, China' }, { code: 'USA', name: 'United States' }, { code: 'GBR', name: 'United Kingdom' },
{ code: 'JPN', name: 'Japan' }, { code: 'SGP', name: 'Singapore' }, { code: 'KOR', name: 'South Korea' },
{ code: 'MYS', name: 'Malaysia' }, { code: 'THA', name: 'Thailand' }, { code: 'VNM', name: 'Vietnam' },
{ code: 'PHL', name: 'Philippines' }, { code: 'IDN', name: 'Indonesia' }, { code: 'IND', name: 'India' },
{ code: 'AUS', name: 'Australia' }, { code: 'NZL', name: 'New Zealand' }, { code: 'CAN', name: 'Canada' },
{ code: 'DEU', name: 'Germany' }, { code: 'FRA', name: 'France' }, { code: 'ITA', name: 'Italy' },
{ code: 'ESP', name: 'Spain' }, { code: 'NLD', name: 'Netherlands' }, { code: 'CHE', name: 'Switzerland' },
{ code: 'SWE', name: 'Sweden' }, { code: 'NOR', name: 'Norway' }, { code: 'DNK', name: 'Denmark' },
{ code: 'FIN', name: 'Finland' }, { code: 'RUS', name: 'Russia' }, { code: 'BRA', name: 'Brazil' },
{ code: 'MEX', name: 'Mexico' }, { code: 'ZAF', name: 'South Africa' }, { code: 'ARE', name: 'United Arab Emirates' },
{ code: 'SAU', name: 'Saudi Arabia' }, { code: 'TUR', name: 'Turkey' }, { code: 'OTHER', name: 'Other' }
],
// 🔹 Industry/Occupation Type - Numeric codes (3-digit)
industryOptions: [
{ label: '001 Government/Public Sector', value: '001' },
{ label: '002 Education', value: '002' },
{ label: '003 Utilities', value: '003' },
{ label: '004 Finance/Banking', value: '004' },
{ label: '005 Insurance', value: '005' },
{ label: '006 Securities & Commodities Trading', value: '006' },
{ label: '007 Legal', value: '007' },
{ label: '008 Medical/Healthcare', value: '008' },
{ label: '009 IT/Internet', value: '009' },
{ label: '010 Electronics', value: '010' },
{ label: '011 Communications/Telecom', value: '011' },
{ label: '012 Media/Film/Advertising/Arts & Culture', value: '012' },
{ label: '013 Retail/E-commerce', value: '013' },
{ label: '014 Catering/Entertainment & Recreation', value: '014' },
{ label: '015 Real Estate', value: '015' },
{ label: '016 Construction/Engineering', value: '016' },
{ label: '017 Logistics/Transport/Shipping/Aviation', value: '017' },
{ label: '018 Tourism/Hotels', value: '018' },
{ label: '019 Beauty/Wellness', value: '019' },
{ label: '020 Business Services', value: '020' },
{ label: '021 Virtual Currency/Crypto Dealers', value: '021' },
{ label: '022 Aircraft/Automobile/Yacht Dealers', value: '022' },
{ label: '023 Charities', value: '023' },
{ label: '024 Pawnbroking', value: '024' },
{ label: '025 Arms', value: '025' },
{ label: '026 Antiques/Auction', value: '026' },
{ label: '027 Manufacturing/Textiles/Agriculture, Forestry & Fisheries', value: '027' },
{ label: '028 Wholesale/Import-Export/Trading', value: '028' },
{ label: '029 Jewelry/Gemstone/Precious Metals Dealers', value: '029' },
{ label: '030 Money Exchange', value: '030' },
{ label: '031 Gaming/Casino', value: '031' },
{ label: '032 Online Gaming', value: '032' },
{ label: '033 Gas, Petroleum, Coal Products & Mining', value: '033' },
{ label: '035 Aerospace/Aerospace Technology', value: '035' },
{ label: '036 Chemicals & Chemical Products', value: '036' },
{ label: '037 Tobacco, Alcoholic Beverages', value: '037' },
{ label: '038 Construction Raw Materials', value: '038' },
{ label: '039 Chips & Semiconductors', value: '039' },
{ label: '999 Other', value: '999' }
],
// 🔹 Position/Job Title - Numeric codes (1-3)
positionOptions: [
{ label: '1 Rank-and-File Employee', value: '1' },
{ label: '2 Middle Management', value: '2' },
{ label: '3 Senior Management/Executive', value: '3' }
],
// 🔹 Account Purpose - 2-digit codes
purposeOptions: [
{ label: '01 Personal Shopping (Cardholder Self-use)', value: '01' },
{ label: '02 Salary/Bonus Disbursement & Withdrawal', value: '02' },
{ label: '03 Personal Purchasing Agent', value: '03' },
{ label: '05 Daily Small Expenses', value: '05' },
{ label: '06 Personal Financial Debt Payment', value: '06' },
{ label: '08 Payment for Friends', value: '08' },
{ label: '99 Other', value: '99' }
],
// 🔹 Source of Wealth - 2-digit codes
wealthOptions: [
{ label: '01 Salary', value: '01' },
{ label: '02 Investment Income', value: '02' },
{ label: '03 Business Income', value: '03' },
{ label: '04 Gambling/Betting Winnings', value: '04' },
{ label: '05 Property/Asset Sale', value: '05' },
{ label: '06 Inheritance', value: '06' },
{ label: '07 Other (Please specify)', value: '07' }
],
termsVisible: false,
termsAgreed: false,
canAgree: false,
applicationFormVisible: false,
currentStep: 1,
previewVisible: false,
previewData: null,
formData: {
username: '',
trustAccount: '',
Name: '',
gender: '',
title: '',
nationality: '',
idNumber: '',
phone: '',
phoneCode: '+852',
email: '',
address: '',
englishName: '',
idType: '',
idIssueDate: '',
idExpiryDate: '',
idAddress: '',
dateOfBirth: '',
occupation: '',
jobTitle: '',
yearsOfService: '',
yearlyIncome: '',
companyName: '',
officeAddress: '',
officeTel: '',
officeTelCode: '+852',
accountPurpose: '',
sourceOfWealth: '',
sourceOfWealthOther: '',
paymentPassword: '', // ✅ 新增支付密码字段
busiWaterNo: '', // 🔹 后端返回的流水号
// 主卡证件上传
idDocFrontFileList: [],
idDocFrontUrl: '',
idDocFrontUrl_raw: null,
idDocBackFileList: [],
idDocBackUrl: '',
idDocBackUrl_raw: null,
idDocInfoFileList: [],
idDocInfoUrl: '',
idDocInfoUrl_raw: null,
// 主卡
cardName1: '',
cardType1: '',
showNameOnCard1: true,
showLogoOnCard1: true,
// 主卡签名
signatureData1: '',
isSigned1: false,
// 附属卡 1
cardName2Chinese: '',
cardName2: '',
gender2: '',
nationality2: '',
idNumber2: '',
idType2: '',
dateOfBirth2: '',
idIssueDate2: '',
idExpiryDate2: '',
idAddress2: '',
phone2: '',
phoneCode2: '+852',
email2: '',
address2: '',
occupation2: '',
jobTitle2: '',
yearsOfService2: '',
yearlyIncome2: '',
companyName2: '',
officeAddress2: '',
officeTel2: '',
officeTelCode2: '+852',
accountPurpose2: '',
sourceOfWealth2: '',
sourceOfWealthOther2: '',
cardType2: '',
showNameOnCard2: true,
showLogoOnCard2: true,
creditLimit2: '',
idDocFrontFileList2: [],
idDocFrontUrl2: '',
idDocFrontUrl2_raw: null,
idDocBackFileList2: [],
idDocBackUrl2: '',
idDocBackUrl2_raw: null,
idDocInfoFileList2: [],
idDocInfoUrl2: '',
idDocInfoUrl2_raw: null,
// 附属卡 1 签名
signatureData2: '',
isSigned2: false,
// 附属卡 2
cardName3Chinese: '',
cardName3: '',
gender3: '',
nationality3: '',
idNumber3: '',
idType3: '',
dateOfBirth3: '',
idIssueDate3: '',
idExpiryDate3: '',
idAddress3: '',
phone3: '',
phoneCode3: '+852',
email3: '',
address3: '',
occupation3: '',
jobTitle3: '',
yearsOfService3: '',
yearlyIncome3: '',
companyName3: '',
officeAddress3: '',
officeTel3: '',
officeTelCode3: '+852',
accountPurpose3: '',
sourceOfWealth3: '',
sourceOfWealthOther3: '',
cardType3: '',
showNameOnCard3: true,
showLogoOnCard3: true,
creditLimit3: '',
idDocFrontFileList3: [],
idDocFrontUrl3: '',
idDocFrontUrl3_raw: null,
idDocBackFileList3: [],
idDocBackUrl3: '',
idDocBackUrl3_raw: null,
idDocInfoFileList3: [],
idDocInfoUrl3: '',
idDocInfoUrl3_raw: null,
// 附属卡 2 签名
signatureData3: '',
isSigned3: false,
showCard2: false,
showCard3: false,
allowedCards: []
},
cardTypeLabels: { gold: 'Gold Card', platinum: 'Platinum Card', black: 'Black Card' },
currentUserInfo: null,
queryVisible: false,
detailVisible: false,
queryForm: { type: 'trust', value: '', captchaInput: '' },
captchaCode: '',
currentApplication: null,
approvalDatabase: [
{
appNo: 'APP20260115A',
trustAccount: 'C123456',
idNumber: 'A123456(7)',
product: 'GFOA Exclusive Trust Gold Card',
submitTime: '2026-01-10 14:30',
status: 'reviewing',
stepIndex: 1,
missingDocs: '',
trackingNumber: '',
trackingUrl: '',
creditLimit: 'HKD 200,000',
billingDay: '15th of each month',
repaymentDay: '30th of each month',
subCards: [{ name: 'Zhang Xiaowei', status: 'approved' }]
},
{
appNo: 'APP20260114B',
trustAccount: 'C789012',
idNumber: 'P78901234',
product: 'GFOA Black Card',
submitTime: '2026-01-09 10:15',
status: 'pending_docs',
stepIndex: 1,
missingDocs: 'Missing supplementary card ID front/back and proof of address',
trackingNumber: '',
trackingUrl: '',
creditLimit: '',
billingDay: '',
repaymentDay: '',
subCards: []
}
]
};
},
computed: {
availableCardTypes() {
const allCardOptions = [
{ value: 'gold', label: 'Gold Card', id: 1, visible: false },
{ value: 'platinum', label: 'Platinum Card', id: 2, visible: false },
{ value: 'black', label: 'Black Card', id: 3, visible: false }
];
const allowed = this.formData.allowedCards || [];
allCardOptions.forEach(option => {
option.visible = allowed.includes(option.id);
});
return allCardOptions;
}
},
methods: {
// 🔐 MD5 加密（轻量原生实现，无需额外依赖）
md5(str) {
function md5cycle(x, k) {
let a=x[0], b=x[1], c=x[2], d=x[3];
a=ff(a,b,c,d,k[0],7,-680876936);d=ff(d,a,b,c,k[1],12,-389564586);c=ff(c,d,a,b,k[2],17,606105819);b=ff(b,c,d,a,k[3],22,-1044525330);
a=ff(a,b,c,d,k[4],7,-176418897);d=ff(d,a,b,c,k[5],12,1200080426);c=ff(c,d,a,b,k[6],17,-1473231341);b=ff(b,c,d,a,k[7],22,-45705983);
a=ff(a,b,c,d,k[8],7,1770035416);d=ff(d,a,b,c,k[9],12,-1958414417);c=ff(c,d,a,b,k[10],17,-42063);b=ff(b,c,d,a,k[11],22,-1990404162);
a=ff(a,b,c,d,k[12],7,1804603682);d=ff(d,a,b,c,k[13],12,-40341101);c=ff(c,d,a,b,k[14],17,-1502002290);b=ff(b,c,d,a,k[15],22,1236535329);
a=gg(a,b,c,d,k[1],5,-165796510);d=gg(d,a,b,c,k[6],9,-1069501632);c=gg(c,d,a,b,k[11],14,643717713);b=gg(b,c,d,a,k[0],20,-373897302);
a=gg(a,b,c,d,k[5],5,-701558691);d=gg(d,a,b,c,k[10],9,38016083);c=gg(c,d,a,b,k[15],14,-660478335);b=gg(b,c,d,a,k[4],20,-405537848);
a=gg(a,b,c,d,k[9],5,568446438);d=gg(d,a,b,c,k[14],9,-1019803690);c=gg(c,d,a,b,k[3],14,-187363961);b=gg(b,c,d,a,k[8],20,1163531501);
a=gg(a,b,c,d,k[13],5,-1444681467);d=gg(d,a,b,c,k[2],9,-51403784);c=gg(c,d,a,b,k[7],14,1735328473);b=gg(b,c,d,a,k[12],20,-1926607734);
a=hh(a,b,c,d,k[5],4,-378558);d=hh(d,a,b,c,k[8],11,-2022574463);c=hh(c,d,a,b,k[11],16,1839030562);b=hh(b,c,d,a,k[14],23,-35309556);
a=hh(a,b,c,d,k[1],4,-1530992060);d=hh(d,a,b,c,k[4],11,1272893353);c=hh(c,d,a,b,k[7],16,-155497632);b=hh(b,c,d,a,k[10],23,-1094730640);
a=hh(a,b,c,d,k[13],4,681279174);d=hh(d,a,b,c,k[0],11,-358537222);c=hh(c,d,a,b,k[3],16,-722521979);b=hh(b,c,d,a,k[6],23,76029189);
a=hh(a,b,c,d,k[9],4,-640364487);d=hh(d,a,b,c,k[12],11,-421815835);c=hh(c,d,a,b,k[15],16,530742520);b=hh(b,c,d,a,k[2],23,-995338651);
a=ii(a,b,c,d,k[0],6,-198630844);d=ii(d,a,b,c,k[7],10,1126891415);c=ii(c,d,a,b,k[14],15,-1416354905);b=ii(b,c,d,a,k[5],21,-57434055);
a=ii(a,b,c,d,k[12],6,1700485571);d=ii(d,a,b,c,k[3],10,-1894986606);c=ii(c,d,a,b,k[10],15,-1051523);b=ii(b,c,d,a,k[1],21,-2054922799);
a=ii(a,b,c,d,k[8],6,1873313359);d=ii(d,a,b,c,k[15],10,-30611744);c=ii(c,d,a,b,k[6],15,-1560198380);b=ii(b,c,d,a,k[13],21,1309151649);
a=ii(a,b,c,d,k[4],6,-145523070);d=ii(d,a,b,c,k[11],10,-1120210379);c=ii(c,d,a,b,k[2],15,718787259);b=ii(b,c,d,a,k[9],21,-343485551);
x[0]=add32(a,x[0]);x[1]=add32(b,x[1]);x[2]=add32(c,x[2]);x[3]=add32(d,x[3]);
}
function cmn(q,a,b,x,s,t){a=add32(add32(a,q),add32(x,t));return add32((a<<s)|(a>>>(32-s)),b);}
function ff(a,b,c,d,x,s,t){return cmn((b&c)|((~b)&d),a,b,x,s,t);}
function gg(a,b,c,d,x,s,t){return cmn((b&d)|(c&(~d)),a,b,x,s,t);}
function hh(a,b,c,d,x,s,t){return cmn(b^c^d,a,b,x,s,t);}
function ii(a,b,c,d,x,s,t){return cmn(c^(b|(~d)),a,b,x,s,t);}
function md51(s){let n=s.length,state=[1732584193,-271733879,-1732584194,271733878],i;for(i=64;i<=s.length;i+=64)md5cycle(state,md5blk(s.substring(i-64,i)));s=s.substring(i-64);let tail=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(i=0;i<s.length;i++)tail[i>>2]|=s.charCodeAt(i)<<((i%4)<<3);tail[i>>2]|=0x80<<((i%4)<<3);if(i>55){md5cycle(state,tail);for(i=0;i<16;i++)tail[i]=0;}tail[14]=n*8;md5cycle(state,tail);return state;}
function md5blk(s){let md5blks=[],i;for(i=0;i<64;i+=4)md5blks[i>>2]=s.charCodeAt(i)+(s.charCodeAt(i+1)<<8)+(s.charCodeAt(i+2)<<16)+(s.charCodeAt(i+3)<<24);return md5blks;}
let hex_chr='0123456789abcdef';
function rhex(n){let s='',j=0;for(;j<4;j++)s+=hex_chr.charAt((n>>(j*8+4))&0x0F)+hex_chr.charAt((n>>(j*8))&0x0F);return s;}
function hex(x){for(let i=0;i<x.length;i++)x[i]=rhex(x[i]);return x.join('');}
function add32(a,b){return(a+b)&0xFFFFFFFF;}
return hex(md51(str));
},
// 🔄 中文转大写拼音（备用方法，现主要用英文输入校验）
toPinyinUpper(chineseStr) {
if (!chineseStr) return '';
const map = {"阿":"A","啊":"A","埃":"Ai","艾":"Ai","爱":"Ai","安":"An","白":"Bai","百":"Bai","柏":"Bai","班":"Ban","邦":"Bang","包":"Bao","宝":"Bao","鲍":"Bao","贝":"Bei","倍":"Bei","毕":"Bi","边":"Bian","卞":"Bian","别":"Bie","宾":"Bin","冰":"Bing","兵":"Bing","波":"Bo","伯":"Bo","博":"Bo","步":"Bu","蔡":"Cai","曹":"Cao","曾":"Zeng","查":"Zha","昌":"Chang","常":"Chang","车":"Che","陈":"Chen","晨":"Chen","成":"Cheng","程":"Cheng","池":"Chi","仇":"Qiu","初":"Chu","褚":"Chu","崔":"Cui","戴":"Dai","代":"Dai","党":"Dang","邓":"Deng","刁":"Diao","丁":"Ding","董":"Dong","窦":"Dou","杜":"Du","段":"Duan","范":"Fan","方":"Fang","费":"Fei","冯":"Feng","符":"Fu","傅":"Fu","高":"Gao","戈":"Ge","葛":"Ge","耿":"Geng","宫":"Gong","龚":"Gong","贡":"Gong","谷":"Gu","顾":"Gu","关":"Guan","冠":"Guan","管":"Guan","光":"Guang","郭":"Guo","韩":"Han","杭":"Hang","郝":"Hao","何":"He","贺":"He","洪":"Hong","侯":"Hou","胡":"Hu","华":"Hua","滑":"Hua","怀":"Huai","霍":"Huo","纪":"Ji","季":"Ji","贾":"Jia","江":"Jiang","姜":"Jiang","蒋":"Jiang","焦":"Jiao","金":"Jin","靳":"Jin","景":"Jing","柯":"Ke","康":"Kang","孔":"Kong","赖":"Lai","兰":"Lan","郎":"Lang","劳":"Lao","雷":"Lei","黎":"Li","李":"Li","厉":"Li","连":"Lian","廉":"Lian","梁":"Liang","廖":"Liao","林":"Lin","凌":"Ling","刘":"Liu","柳":"Liu","龙":"Long","卢":"Lu","鲁":"Lu","路":"Lu","陆":"Lu","吕":"Lv","罗":"Luo","麻":"Ma","马":"Ma","茅":"Mao","梅":"Mei","孟":"Meng","米":"Mi","闵":"Min","莫":"Mo","母":"Mu","穆":"Mu","那":"Na","南":"Nan","倪":"Ni","聂":"Nie","宁":"Ning","牛":"Niu","农":"Nong","欧":"Ou","潘":"Pan","庞":"Pang","裴":"Pei","彭":"Peng","蒲":"Pu","朴":"Pu","齐":"Qi","祁":"Qi","钱":"Qian","秦":"Qin","邱":"Qiu","仇":"Qiu","曲":"Qu","全":"Quan","饶":"Rao","任":"Ren","荣":"Rong","阮":"Ruan","芮":"Rui","桑":"Sang","沙":"Sha","山":"Shan","尚":"Shang","邵":"Shao","申":"Shen","沈":"Shen","盛":"Sheng","施":"Shi","史":"Shi","舒":"Shu","水":"Shui","司":"Si","宋":"Song","苏":"Su","孙":"Sun","汤":"Tang","唐":"Tang","陶":"Tao","滕":"Teng","田":"Tian","童":"Tong","涂":"Tu","万":"Wan","汪":"Wang","王":"Wang","危":"Wei","韦":"Wei","魏":"Wei","温":"Wen","文":"Wen","闻":"Wen","翁":"Weng","巫":"Wu","邬":"Wu","吴":"Wu","武":"Wu","伍":"Wu","奚":"Xi","席":"Xi","夏":"Xia","向":"Xiang","项":"Xiang","萧":"Xiao","肖":"Xiao","谢":"Xie","辛":"Xin","邢":"Xing","熊":"Xiong","徐":"Xu","许":"Xu","薛":"Xue","阎":"Yan","严":"Yan","言":"Yan","晏":"Yan","燕":"Yan","杨":"Yang","姚":"Yao","叶":"Ye","易":"Yi","尹":"Yin","殷":"Yin","应":"Ying","尤":"You","于":"Yu","余":"Yu","俞":"Yu","虞":"Yu","袁":"Yuan","云":"Yun","曾":"Zeng","臧":"Zang","詹":"Zhan","湛":"Zhan","章":"Zhang","张":"Zhang","赵":"Zhao","郑":"Zheng","仲":"Zhong","周":"Zhou","朱":"Zhu","庄":"Zhuang","卓":"Zhuo","子":"Zi","宗":"Zong","邹":"Zou","左":"Zuo"};
return chineseStr.split('').map(c => map[c] || c).join('').toUpperCase().replace(/\s+/g, '');
},
// 🔢 生成22位流水号（降级方案，当后端接口失败时使用）
generateSerial22() {
const ts = Date.now().toString().padStart(13, '0');
const rand = Math.random().toString(36).substring(2, 11).toUpperCase();
return (ts + rand).substring(0, 22).padEnd(22, 'X');
},
// 🔹 从后端获取流水号
async fetchSerialNumber() {
try {
const response = await axios.get('http://172.30.20.34:9190/internal/card/generate', {
timeout: 10000
});
if (response.data && response.data.code === 200) {
console.log('✅ Serial number fetched:', response.data.data);
return response.data.data;
} else {
console.warn('⚠️ Fetch serial number failed, fallback to local generation');
return this.generateSerial22();
}
} catch (error) {
console.error('❌ Error fetching serial number:', error);
return this.generateSerial22(); // 网络异常时使用本地生成
}
},
// ✅ 新增：处理英文名输入 - 只允许英文字母和空格，自动转大写
handleEnglishNameInput(value) {
if (!value) {
this.formData.englishName = '';
return;
}
// 只允许英文字母和空格，自动转大写，合并多个空格
this.formData.englishName = value
.replace(/[^a-zA-Z\s]/g, '')
.toUpperCase()
.replace(/\s{2,}/g, ' ')
.trim();
},
// ✅ 新增：处理签名组件的 input 事件
handleSignatureUpdate(index, value) {
this.formData[`signatureData${index}`] = value;
this.formData[`isSigned${index}`] = !!value && value.length > 100;
},
// ✅ 新增：清除签名（调用子组件方法）
clearSignature(index) {
const refName = `sigPad${index}`;
if (this.$refs[refName] && this.$refs[refName][0]) {
this.$refs[refName][0].clear();
}
},
// 🔹 辅助方法：国家名称转代码
getCountryCode(countryName) {
const country = this.countryList.find(c => c.name === countryName);
return country ? country.code : 'OTHER';
},
// 🔹 辅助方法：性别转代码
getSexCode(gender) {
return gender === 'male' ? 'M' : gender === 'female' ? 'F' : '';
},
// 🔹 辅助方法：证件类型转代码
getCertTypeCode(idType) {
const map = {
'MainlandID': '01',
'HKID': '02',
'Passport': '03',
'Other': '04'
};
return map[idType] || '04';
},
checkUrlToken() {
const query = this.$route?.query || {};
const testMode = query.test;
const token = query.token;
const callback = query.callback;
this.adminCallbackUrl = callback || '';
if (testMode === 'uCFYP7pxXzXDSd5ubDKakwxK' && !token) {
console.log('🧪 Test mode enabled');
this.urlToken = 'mock_token_for_testing';
this.verifyToken(true);
return;
}
if (token) {
console.log('🔑 Token found:', token);
this.urlToken = token;
this.verifyToken(false);
return;
}
console.warn('⚠️ No token provided');
this.tokenValid = false;
this.loading = false;
this.$message.error('Access denied: Missing token parameter');
},
async verifyToken(isMock = false) {
try {
let response;
if (isMock) {
response = {
data: {
status: 1,
message: 'Token verified (mock)',
data: {
username: 'C123456',
name: '张三',
gender: 'male',
title: 'Mr.',
phone: '13800138000',
address: '123 Test Street, Hong Kong',
nationality: 'China',
idNumber: 'A123456(7)',
email: 'test@example.com',
allowedCards: [1, 2, 3]
}
}
};
await new Promise(resolve => setTimeout(resolve, 500));
} else {
response = await axios.post(
'http://172.30.20.33/new_hkt/api/misc/verify_token',
{ token: this.urlToken },
{
headers: { 'Content-Type': 'application/json' },
timeout: 10000
}
);
}
if (response.data && response.data.status === 1) {
this.tokenValid = true;
const userData = response.data.data;
this.formData.username = userData.username || '';
this.formData.trustAccount = userData.username || '';
this.formData.Name = userData.name || '';
this.formData.englishName = userData.name; // ✅ 自动填充拼音
this.formData.gender = userData.gender || '';
this.formData.title = userData.title || '';
this.formData.phone = userData.phone || '';
this.formData.address = userData.address || '';
this.formData.nationality = userData.nationality || '';
this.formData.idNumber = userData.idNumber || '';
this.formData.email = userData.email || '';
this.formData.allowedCards = Array.isArray(userData.allowedCards) ? userData.allowedCards : [];
this.currentUserInfo = userData;
this.$message.success('Token verified successfully!' + (isMock ? ' (Test Mode)' : ''));
this.cleanUrlToken();
} else {
this.tokenValid = false;
this.$message.error('Token verification failed: ' + (response.data.message || 'Invalid token'));
}
} catch (error) {
console.error('Token verification error:', error);
this.tokenValid = false;
if (error.response) {
this.$message.error(`API Error ${error.response.status}: ${error.response.data?.message || 'Verification failed'}`);
} else if (error.request) {
this.$message.error('Network error: Unable to connect to verification server');
} else {
this.$message.error('Token verification error. Please contact administrator.');
}
} finally {
this.loading = false;
}
},
cleanUrlToken() {
const cleanPath = window.location.pathname + window.location.hash.split('?')[0];
window.history.replaceState({}, document.title, cleanPath);
console.log('🧹 URL cleaned, token hidden from address bar');
if (this.$router?.currentRoute?.query?.token) {
this.$router.replace({
path: this.$route.path,
query: {
...this.$route.query,
token: undefined,
test: undefined,
callback: undefined
}
}).catch(() => {});
}
},
startApplication() {
if (!this.tokenValid) {
this.$message.error('Please verify token first');
return;
}
this.openTermsDialog();
},
async openTermsDialog() {
this.termsVisible = true;
this.termsAgreed = false;
this.canAgree = false;
this.$nextTick(() => {
if (this.$refs.termsContentRef) this.$refs.termsContentRef.scrollTop = 0;
});
if (this.currentUserInfo) {
this.loadCustomerData();
}
// 🔹 获取并填充流水号
const serialNo = await this.fetchSerialNumber();
this.formData.busiWaterNo = serialNo;
},
closeTermsDialog() {
this.termsVisible = false;
this.termsAgreed = false;
this.canAgree = false;
},
handleTermsScroll(event) {
const el = event.target;
this.canAgree = (el.scrollHeight - el.scrollTop <= el.clientHeight + 5);
},
acceptTerms() {
if (this.termsAgreed) {
this.termsVisible = false;
this.applicationFormVisible = true;
this.currentStep = 1;
}
},
loadCustomerData() {
if (this.currentUserInfo) {
const info = this.currentUserInfo;
this.formData.username = info.username || '';
this.formData.trustAccount = info.username || '';
this.formData.Name = info.name || '';
this.formData.englishName = info.englishName;
this.formData.title = info.title || '';
this.formData.gender = info.gender || '';
this.formData.phone = info.phone || '';
this.formData.address = info.address || '';
this.formData.nationality = info.nationality || '';
this.formData.idNumber = info.idNumber || '';
this.formData.email = info.email || '';
this.formData.allowedCards = Array.isArray(info.allowedCards) ? info.allowedCards : [];
}
},
// 🔹 核心修改：只要不是大陆身份证，到期时间默认 9999-12-31
handleIdTypeChange() {
this.formData.idDocFrontFileList = [];
this.formData.idDocBackFileList = [];
this.formData.idDocInfoFileList = [];
this.formData.idDocFrontUrl = '';
this.formData.idDocBackUrl = '';
this.formData.idDocInfoUrl = '';
this.formData.idDocFrontUrl_raw = null;
this.formData.idDocBackUrl_raw = null;
this.formData.idDocInfoUrl_raw = null;
  
if (this.formData.idType === 'MainlandID') {
this.formData.idExpiryDate = ''; // 大陆身份证需要用户选择
} else {
this.formData.idExpiryDate = '9999-12-31'; // 其他所有类型默认长期
}
},

handleIdTypeChange2() {
this.formData.idDocFrontFileList2 = [];
this.formData.idDocBackFileList2 = [];
this.formData.idDocInfoFileList2 = [];
this.formData.idDocFrontUrl2 = '';
this.formData.idDocBackUrl2 = '';
this.formData.idDocInfoUrl2 = '';
this.formData.idDocFrontUrl2_raw = null;
this.formData.idDocBackUrl2_raw = null;
this.formData.idDocInfoUrl2_raw = null;
  
if (this.formData.idType2 === 'MainlandID') {
this.formData.idExpiryDate2 = '';
} else {
this.formData.idExpiryDate2 = '9999-12-31';
}
},

handleIdTypeChange3() {
this.formData.idDocFrontFileList3 = [];
this.formData.idDocBackFileList3 = [];
this.formData.idDocInfoFileList3 = [];
this.formData.idDocFrontUrl3 = '';
this.formData.idDocBackUrl3 = '';
this.formData.idDocInfoUrl3 = '';
this.formData.idDocFrontUrl3_raw = null;
this.formData.idDocBackUrl3_raw = null;
this.formData.idDocInfoUrl3_raw = null;
  
if (this.formData.idType3 === 'MainlandID') {
this.formData.idExpiryDate3 = '';
} else {
this.formData.idExpiryDate3 = '9999-12-31';
}
},
handlePurposeChange() {
if (this.formData.accountPurpose !== '99') {}
},
handlePurposeChange2() {
if (this.formData.accountPurpose2 !== '99') {}
},
handlePurposeChange3() {
if (this.formData.accountPurpose3 !== '99') {}
},
handleWealthChange() {
if (this.formData.sourceOfWealth !== '07') {
this.formData.sourceOfWealthOther = '';
}
},
handleWealthChange2() {
if (this.formData.sourceOfWealth2 !== '07') {
this.formData.sourceOfWealthOther2 = '';
}
},
handleWealthChange3() {
if (this.formData.sourceOfWealth3 !== '07') {
this.formData.sourceOfWealthOther3 = '';
}
},
handleIdUpload(file, targetUrlField, targetFileList) {
console.log('📁 File selected:', file.name, file.size, file.raw?.type);
const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
const fileType = file.raw?.type || file.type;
const isAllowedType = allowedTypes.includes(fileType);
if (!isAllowedType) {
this.$message.error('Supports JPG, PNG, or PDF formats only');
this.formData[targetFileList] = [];
this.$set(this.formData, targetUrlField, '');
this.$set(this.formData, targetUrlField + '_raw', null);
return false;
}
const limitSize = 5 * 1024 * 1024;
const fileSize = file.size || file.raw?.size || 0;
if (fileSize > limitSize) {
this.$message.error('File size must not exceed 5MB!');
this.formData[targetFileList] = [];
this.$set(this.formData, targetUrlField, '');
this.$set(this.formData, targetUrlField + '_raw', null);
return false;
}
const fileObj = {
name: file.name || file.raw?.name || 'uploaded_file',
size: fileSize,
type: fileType,
status: 'ready',
uid: Date.now() + Math.random()
};
this.$set(this.formData, targetUrlField + '_raw', file.raw || file);
this.$set(this.formData, targetFileList, [fileObj]);
this.$message.success('File selected successfully. Will upload on final submission.');
this.$forceUpdate();
return false;
},
handlePhoneInput(cardIndex, value) {
const cleanValue = value.replace(/\D/g, '');
if (cardIndex === 1) {
this.$set(this.formData, 'phone', cleanValue);
} else if (cardIndex === 2) {
this.$set(this.formData, 'phone2', cleanValue);
} else if (cardIndex === 3) {
this.$set(this.formData, 'phone3', cleanValue);
}
},
openQueryDialog() {
this.queryVisible = true;
this.queryForm = { type: 'trust', value: '', captchaInput: '' };
this.$nextTick(() => {
this.generateCaptcha();
});
},
generateCaptcha() {
const code = Math.floor(1000 + Math.random() * 9000).toString();
this.captchaCode = code;
const canvas = this.$refs.captchaCanvas;
if (!canvas) return;
const ctx = canvas.getContext('2d');
ctx.clearRect(0, 0, canvas.width, canvas.height);
ctx.font = '24px Arial';
ctx.fillStyle = '#333';
ctx.fillText(code, 15, 30);
for (let i = 0; i < 5; i++) {
ctx.strokeStyle = `rgb(${Math.floor(Math.random()*200)},${Math.floor(Math.random()*200)},${Math.floor(Math.random()*200)})`;
ctx.beginPath();
ctx.moveTo(Math.random()*100, Math.random()*40);
ctx.lineTo(Math.random()*100, Math.random()*40);
ctx.stroke();
}
},
handleQuery() {
if (!this.queryForm.value.trim()) {
this.$message.warning('Please enter your search criteria');
return;
}
if (!this.queryForm.captchaInput.trim()) {
this.$message.warning('Please enter the CAPTCHA');
return;
}
if (this.queryForm.captchaInput !== this.captchaCode) {
this.$message.error('Graphical CAPTCHA error');
this.generateCaptcha();
return;
}
let record = null;
if (this.queryForm.type === 'trust') {
record = this.approvalDatabase.find(item => item.trustAccount === this.queryForm.value);
} else {
record = this.approvalDatabase.find(item => item.idNumber === this.queryForm.value);
}
if (record) {
this.currentApplication = { ...record };
this.queryVisible = false;
this.detailVisible = true;
} else {
this.$message.error('No relevant application records were found.');
}
},
getStatusText(status) {
const map = { submitted: 'Submitted', reviewing: 'Under review', pending_docs: 'To be supplemented', approved: 'Approved', rejected: 'Not approved' };
return map[status] || 'Unknown';
},
getStatusColor(status) {
const map = { submitted: '#60a5fa', reviewing: '#3b82f6', pending_docs: '#f59e0b', approved: '#10b981', rejected: '#ef4444' };
return map[status] || '#64748b';
},
getFinalStatusDesc(status) {
if (status === 'approved') return 'Success';
if (status === 'rejected') return 'Refusal';
if (status === 'pending_docs') return 'Additional documentation is required.';
return 'Pending';
},
// ✅ 修改：英文名输入校验 - 只允许英文字母和空格，自动转大写
sanitizeEnglishName(name) {
if (!name) return '';
// 只允许英文字母和空格，自动转大写，合并多个空格
return name
.replace(/[^a-zA-Z\s]/g, '')
.toUpperCase()
.replace(/\s{2,}/g, ' ')
.trim();
},
handleCardName1Input(value) { this.formData.cardName1 = this.sanitizeEnglishName(value); },
handleCardName2Input(value) { this.formData.cardName2 = this.sanitizeEnglishName(value); },
handleCardName3Input(value) { this.formData.cardName3 = this.sanitizeEnglishName(value); },
nextStep() {
if (this.currentStep === 1) {
if (!this.formData.englishName || !this.formData.idType || !this.formData.dateOfBirth || !this.formData.occupation) {
this.$message.warning('Please complete all required fields in Step 1');
return;
}
if (this.formData.idType === 'MainlandID') {
const hasFront = this.formData.idDocFrontUrl_raw || (this.formData.idDocFrontFileList?.length > 0);
const hasBack = this.formData.idDocBackUrl_raw || (this.formData.idDocBackFileList?.length > 0);
if (!hasFront || !hasBack) {
this.$message.warning('Please upload both front and back of your ID');
return;
}
} else {
const hasInfo = this.formData.idDocInfoUrl_raw || (this.formData.idDocInfoFileList?.length > 0);
if (!hasInfo) {
this.$message.warning('Please upload your ID/Passport information page');
return;
}
}
}
if (this.currentStep < 2) this.currentStep++;
},
prevStep() { if (this.currentStep > 1) this.currentStep--; },
toggleCard2() {
this.$set(this.formData, 'showCard2', !this.formData.showCard2);
if (!this.formData.showCard2) {
this.formData.cardName2Chinese = '';
this.formData.cardName2 = ''; this.formData.gender2 = ''; this.formData.nationality2 = '';
this.formData.idNumber2 = ''; this.formData.idType2 = ''; this.formData.dateOfBirth2 = '';
this.formData.idIssueDate2 = ''; this.formData.idExpiryDate2 = ''; this.formData.idAddress2 = '';
this.formData.phone2 = ''; this.formData.email2 = ''; this.formData.address2 = '';
this.formData.occupation2 = ''; this.formData.jobTitle2 = '';
this.formData.yearsOfService2 = ''; this.formData.yearlyIncome2 = '';
this.formData.companyName2 = ''; this.formData.officeAddress2 = '';
this.formData.officeTel2 = ''; this.formData.officeTelCode2 = '+852';
this.formData.accountPurpose2 = ''; this.formData.sourceOfWealth2 = '';
this.formData.sourceOfWealthOther2 = '';
this.formData.cardType2 = '';
this.formData.showNameOnCard2 = true; this.formData.showLogoOnCard2 = true;
this.formData.creditLimit2 = '';
this.formData.idDocFrontFileList2 = []; this.formData.idDocBackFileList2 = []; this.formData.idDocInfoFileList2 = [];
this.formData.idDocFrontUrl2_raw = null; this.formData.idDocBackUrl2_raw = null; this.formData.idDocInfoUrl2_raw = null;
this.formData.signatureData2 = ''; this.formData.isSigned2 = false;
this.$set(this.formData, 'showCard3', false);
this.formData.cardName3Chinese = '';
this.formData.cardName3 = ''; this.formData.gender3 = ''; this.formData.nationality3 = '';
this.formData.idNumber3 = ''; this.formData.idType3 = ''; this.formData.dateOfBirth3 = '';
this.formData.idIssueDate3 = ''; this.formData.idExpiryDate3 = ''; this.formData.idAddress3 = '';
this.formData.phone3 = ''; this.formData.email3 = ''; this.formData.address3 = '';
this.formData.occupation3 = ''; this.formData.jobTitle3 = '';
this.formData.yearsOfService3 = ''; this.formData.yearlyIncome3 = '';
this.formData.companyName3 = ''; this.formData.officeAddress3 = '';
this.formData.officeTel3 = ''; this.formData.officeTelCode3 = '+852';
this.formData.accountPurpose3 = ''; this.formData.sourceOfWealth3 = '';
this.formData.sourceOfWealthOther3 = '';
this.formData.cardType3 = '';
this.formData.showNameOnCard3 = true; this.formData.showLogoOnCard3 = true;
this.formData.creditLimit3 = '';
this.formData.idDocFrontFileList3 = []; this.formData.idDocBackFileList3 = []; this.formData.idDocInfoFileList3 = [];
this.formData.idDocFrontUrl3_raw = null; this.formData.idDocBackUrl3_raw = null; this.formData.idDocInfoUrl3_raw = null;
this.formData.signatureData3 = ''; this.formData.isSigned3 = false;
}
},
toggleCard3() {
this.$set(this.formData, 'showCard3', !this.formData.showCard3);
if (!this.formData.showCard3) {
this.formData.cardName3Chinese = '';
this.formData.cardName3 = ''; this.formData.gender3 = ''; this.formData.nationality3 = '';
this.formData.idNumber3 = ''; this.formData.idType3 = ''; this.formData.dateOfBirth3 = '';
this.formData.idIssueDate3 = ''; this.formData.idExpiryDate3 = ''; this.formData.idAddress3 = '';
this.formData.phone3 = ''; this.formData.email3 = ''; this.formData.address3 = '';
this.formData.occupation3 = ''; this.formData.jobTitle3 = '';
this.formData.yearsOfService3 = ''; this.formData.yearlyIncome3 = '';
this.formData.companyName3 = ''; this.formData.officeAddress3 = '';
this.formData.officeTel3 = ''; this.formData.officeTelCode3 = '+852';
this.formData.accountPurpose3 = ''; this.formData.sourceOfWealth3 = '';
this.formData.sourceOfWealthOther3 = '';
this.formData.cardType3 = '';
this.formData.showNameOnCard3 = true; this.formData.showLogoOnCard3 = true;
this.formData.creditLimit3 = '';
this.formData.idDocFrontFileList3 = []; this.formData.idDocBackFileList3 = []; this.formData.idDocInfoFileList3 = [];
this.formData.idDocFrontUrl3_raw = null; this.formData.idDocBackUrl3_raw = null; this.formData.idDocInfoUrl3_raw = null;
this.formData.signatureData3 = ''; this.formData.isSigned3 = false;
}
},
getCharCountClass(len) {
if (len > 20) return 'error';
if (len > 15) return 'warning';
return '';
},
getCardImage(type, showLogo = true) {
if (type === 'gold') {
return showLogo
? require('@/assets/gold-card-with-logo.png')
: require('@/assets/gold-card-no-logo.png');
}
if (type === 'platinum') {
return showLogo
? require('@/assets/platinum-card-with-logo.png')
: require('@/assets/platinum-card-no-logo.png');
}
if (type === 'black') {
return showLogo
? require('@/assets/black-card-with-logo.png')
: require('@/assets/black-card-no-logo.png');
}
return require('@/assets/gold-card.png');
},
boolToText(val) { return val ? 'Yes' : 'No'; },
submitApplication() {
  if (!this.formData.cardType1) {
    this.$message.warning('Please select the card type.');
    return;
  }
  if (!this.formData.isSigned1) {
    this.$message.warning('Primary cardholder signature is required');
    return;
  }
  if (this.formData.showCard2 && !this.formData.isSigned2) {
    this.$message.warning('Supplementary card 1 holder signature is required');
    return;
  }
  if (this.formData.showCard3 && !this.formData.isSigned3) {
    this.$message.warning('Supplementary card 2 holder signature is required');
    return;
  }
  if (this.formData.showCard2) {
    if (!this.formData.cardName2Chinese) {
      this.$message.warning('Please enter Chinese name for Supplementary Card 1');
      return;
    }
    if (!this.formData.gender2 || !this.formData.nationality2 || !this.formData.dateOfBirth2 || !this.formData.idType2 || !this.formData.idNumber2) {
      this.$message.warning('Please complete all required fields for Supplementary Card 1');
      return;
    }
    if (this.formData.idType2 === 'MainlandID') {
      const hasFront2 = this.formData.idDocFrontUrl2_raw || (this.formData.idDocFrontFileList2?.length > 0);
      const hasBack2 = this.formData.idDocBackUrl2_raw || (this.formData.idDocBackFileList2?.length > 0);
      if (!hasFront2 || !hasBack2) {
        this.$message.warning('Please upload ID documents for Supplementary Card 1');
        return;
      }
    } else {
      const hasInfo2 = this.formData.idDocInfoUrl2_raw || (this.formData.idDocInfoFileList2?.length > 0);
      if (!hasInfo2) {
        this.$message.warning('Please upload ID document for Supplementary Card 1');
        return;
      }
    }
    if (!this.formData.creditLimit2) {
      this.$message.warning('Please set credit limit for Supplementary Card 1');
      return;
    }
  }
  if (this.formData.showCard3) {
    if (!this.formData.cardName3Chinese) {
      this.$message.warning('Please enter Chinese name for Supplementary Card 2');
      return;
    }
    if (!this.formData.gender3 || !this.formData.nationality3 || !this.formData.dateOfBirth3 || !this.formData.idType3 || !this.formData.idNumber3) {
      this.$message.warning('Please complete all required fields for Supplementary Card 2');
      return;
    }
    if (this.formData.idType3 === 'MainlandID') {
      const hasFront3 = this.formData.idDocFrontUrl3_raw || (this.formData.idDocFrontFileList3?.length > 0);
      const hasBack3 = this.formData.idDocBackUrl3_raw || (this.formData.idDocBackFileList3?.length > 0);
      if (!hasFront3 || !hasBack3) {
        this.$message.warning('Please upload ID documents for Supplementary Card 2');
        return;
      }
    } else {
      const hasInfo3 = this.formData.idDocInfoUrl3_raw || (this.formData.idDocInfoFileList3?.length > 0);
      if (!hasInfo3) {
        this.$message.warning('Please upload ID document for Supplementary Card 2');
        return;
      }
    }
    if (!this.formData.creditLimit3) {
      this.$message.warning('Please set credit limit for Supplementary Card 2');
      return;
    }
  }
  this.previewData = { ...this.formData };
  this.previewVisible = true;
},
async confirmAndSubmit() {
const loading = this.$loading({
lock: true,
text: 'Processing: Uploading attachments & submitting form...',
background: 'rgba(0,0,0,0.7)'
});
try {
const uploadPromises = [];
const uploadResults = {};
// ========== 主申请人证件上传 ==========
if (this.formData.idDocFrontUrl_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocFrontUrl_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Main Applicant ID Front Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocFrontUrl = res.data.url;
uploadResults.idDocFrontUrl = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Main Applicant ID Front Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Main Applicant ID Front Upload Error:', err);
if (err.response) {
throw new Error('Main Applicant ID Front Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Main Applicant ID Front Upload Failed (Network Timeout)');
} else {
throw new Error('Main Applicant ID Front Upload Failed: ' + err.message);
}
})
);
}
if (this.formData.idDocBackUrl_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocBackUrl_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Main Applicant ID Back Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocBackUrl = res.data.url;
uploadResults.idDocBackUrl = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Main Applicant ID Back Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Main Applicant ID Back Upload Error:', err);
if (err.response) {
throw new Error('Main Applicant ID Back Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Main Applicant ID Back Upload Failed (Network Timeout)');
} else {
throw new Error('Main Applicant ID Back Upload Failed: ' + err.message);
}
})
);
}
if (this.formData.idDocInfoUrl_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocInfoUrl_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Main Applicant ID Info Page Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocInfoUrl = res.data.url;
uploadResults.idDocInfoUrl = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Main Applicant ID Info Page Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Main Applicant ID Info Page Upload Error:', err);
if (err.response) {
throw new Error('Main Applicant ID Info Page Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Main Applicant ID Info Page Upload Failed (Network Timeout)');
} else {
throw new Error('Main Applicant ID Info Page Upload Failed: ' + err.message);
}
})
);
}
// ========== 附属卡 1 证件上传 ==========
if (this.formData.idDocFrontUrl2_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocFrontUrl2_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Supp Card 1 ID Front Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocFrontUrl2 = res.data.url;
uploadResults.idDocFrontUrl2 = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Supp Card 1 ID Front Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Supp Card 1 ID Front Upload Error:', err);
if (err.response) {
throw new Error('Supp Card 1 ID Front Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Supp Card 1 ID Front Upload Failed (Network Timeout)');
} else {
throw new Error('Supp Card 1 ID Front Upload Failed: ' + err.message);
}
})
);
}
if (this.formData.idDocBackUrl2_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocBackUrl2_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Supp Card 1 ID Back Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocBackUrl2 = res.data.url;
uploadResults.idDocBackUrl2 = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Supp Card 1 ID Back Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Supp Card 1 ID Back Upload Error:', err);
if (err.response) {
throw new Error('Supp Card 1 ID Back Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Supp Card 1 ID Back Upload Failed (Network Timeout)');
} else {
throw new Error('Supp Card 1 ID Back Upload Failed: ' + err.message);
}
})
);
}
if (this.formData.idDocInfoUrl2_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocInfoUrl2_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Supp Card 1 ID Info Page Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocInfoUrl2 = res.data.url;
uploadResults.idDocInfoUrl2 = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Supp Card 1 ID Info Page Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Supp Card 1 ID Info Page Upload Error:', err);
if (err.response) {
throw new Error('Supp Card 1 ID Info Page Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Supp Card 1 ID Info Page Upload Failed (Network Timeout)');
} else {
throw new Error('Supp Card 1 ID Info Page Upload Failed: ' + err.message);
}
})
);
}
// ========== 附属卡 2 证件上传 ==========
if (this.formData.idDocFrontUrl3_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocFrontUrl3_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Supp Card 2 ID Front Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocFrontUrl3 = res.data.url;
uploadResults.idDocFrontUrl3 = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Supp Card 2 ID Front Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Supp Card 2 ID Front Upload Error:', err);
if (err.response) {
throw new Error('Supp Card 2 ID Front Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Supp Card 2 ID Front Upload Failed (Network Timeout)');
} else {
throw new Error('Supp Card 2 ID Front Upload Failed: ' + err.message);
}
})
);
}
if (this.formData.idDocBackUrl3_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocBackUrl3_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Supp Card 2 ID Back Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocBackUrl3 = res.data.url;
uploadResults.idDocBackUrl3 = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Supp Card 2 ID Back Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Supp Card 2 ID Back Upload Error:', err);
if (err.response) {
throw new Error('Supp Card 2 ID Back Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Supp Card 2 ID Back Upload Failed (Network Timeout)');
} else {
throw new Error('Supp Card 2 ID Back Upload Failed: ' + err.message);
}
})
);
}
if (this.formData.idDocInfoUrl3_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocInfoUrl3_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Supp Card 2 ID Info Page Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocInfoUrl3 = res.data.url;
uploadResults.idDocInfoUrl3 = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Supp Card 2 ID Info Page Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Supp Card 2 ID Info Page Upload Error:', err);
if (err.response) {
throw new Error('Supp Card 2 ID Info Page Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Supp Card 2 ID Info Page Upload Failed (Network Timeout)');
} else {
throw new Error('Supp Card 2 ID Info Page Upload Failed: ' + err.message);
}
})
);
}
if (uploadPromises.length > 0) {
console.log('📤 Starting upload of', uploadPromises.length, 'files...');
await Promise.all(uploadPromises);
console.log('✅ All files uploaded', uploadResults);
}
// 🔹 组装新接口格式数据（主申请人）
const postData = {
address: this.formData.address || '',
agent: 'HKTCM',
agentRegion: 'HK',
birthday: this.formData.dateOfBirth || '',
busiWaterNo: this.formData.busiWaterNo || this.generateSerial22(), // 🔹 后端流水号，确保有值
cardName: this.formData.cardName1 || '',
cardNo: '', // 卡号由后端生成，留空
cardType: this.formData.cardType1 || '',
certEndDate: this.formData.idExpiryDate || '9999-12-31', // ✅ 双重保险，防止空值
certId: this.formData.idNumber || '',
certStartDate: this.formData.idIssueDate || '',
certType: this.getCertTypeCode(this.formData.idType),
companyName: this.formData.companyName || '',
country: this.getCountryCode(this.formData.nationality), // 🔹 3位国家码
email: this.formData.email || '',
groupId: '',
id: '', // ID置空
idAddress: this.formData.idAddress || '',
idDocBackUrl: this.formData.idDocBackUrl || '',
idDocFrontUrl: this.formData.idDocFrontUrl || '',
idDocInfoUrl: this.formData.idDocInfoUrl || '',
mobNo: this.formData.phone || '',
mobNoOf: (this.formData.phoneCode || '+852').replace('+', ''),
name: this.formData.Name || '',
nameEn: this.formData.englishName || '',
officeAddress: this.formData.officeAddress || '',
officeTel: this.formData.officeTel || '',
officeTelCode: (this.formData.officeTelCode || '+852').replace('+', ''),
payPwd: this.formData.paymentPassword ? this.md5(this.formData.paymentPassword) : '',
position: this.formData.jobTitle || '1', // 🔹 职位编码，默认1
profession: this.formData.occupation || '999', // 🔹 职业编码，默认999
professionOther: this.formData.occupation === '999' ? (this.formData.occupationOther || '') : '',
purpose: this.formData.accountPurpose || '01', // 🔹 开户目的，默认01
purposeOther: this.formData.accountPurpose === '99' ? (this.formData.sourceOfWealthOther || '') : '',
sex: this.getSexCode(this.formData.gender),
showLogoOnCard: this.formData.showLogoOnCard1 ? 'Y' : 'N',
showNameOnCard: this.formData.showNameOnCard1 ? 'Y' : 'N',
trustAccount: this.formData.username || '',
wealthSource: this.formData.sourceOfWealth || '01', // 🔹 财富来源，默认01
wealthSourceOther: this.formData.sourceOfWealth === '07' ? (this.formData.sourceOfWealthOther || '') : '',
yearlyIncome: this.formData.yearlyIncome ? parseInt(this.formData.yearlyIncome) : 0, // 🔹 年收入，确保是数字
yearsOfService: this.formData.yearsOfService || ''
};
console.log('📤 Submitting to new API:', postData);
// 🔹 调用新提交接口
const res = await axios.post(
'http://172.30.20.34:9190/external/activation',
postData,
{
headers: { 'Content-Type': 'application/json' },
timeout: 30000
}
);
if (res.data && res.data.code === 200) {
this.$message.success('Your Prepaid Card application has been successfully submitted!');
// ✅ 提交成功后关闭所有弹窗
this.previewVisible = false;
this.applicationFormVisible = false;
// 如有需要，可处理返回的 applicationId
if (this.adminCallbackUrl && res.data.data?.applicationId) {
this.notifyAdminCallback(res.data.data.applicationId);
}
} else {
this.$message.error('Submission failed: ' + (res.data.msg || 'Unknown error'));
}
} catch (error) {
console.error('❌ Submission Error:', error);
const userMsg = error.response?.data?.msg
|| error.message
|| 'System error: Submission failed';
this.$message.error(userMsg);
} finally {
loading.close();
}
},
async notifyAdminCallback(applicationId) {
try {
await axios.post(this.adminCallbackUrl, {
token: this.urlToken,
applicationId: applicationId,
status: 'submitted',
submitTime: new Date().toISOString()
});
console.log('Admin callback successful');
} catch (error) {
console.error('Admin callback failed:', error);
}
},
goHome() {
window.history.pushState({}, document.title, window.location.pathname);
this.urlToken = '';
this.tokenValid = false;
}
},
mounted() {
this.generateCaptcha();
this.checkUrlToken();
}
};
</script>

<style>
:root {
--bg-light: #f8f9fc;
--primary-color: #1E3A8A;
--accent-color: #F59E0B;
--border-color: #e2e8f0;
--text-primary: #1E293B;
--text-secondary: #64748B;
--text-error: #EF4444;
--bg-white: #fff;
--bg-gray: #f8f9fa;
}
body, html { margin: 0; padding: 0; height: 100%; font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; background-color: var(--bg-light); overflow: hidden; }
.app-wrapper { display: flex; height: 100vh; }
.access-denied { display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #f8f9fc; width: 100%; }
.denied-content { text-align: center; padding: 40px; background: white; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
.denied-content h1 { color: #EF4444; margin-bottom: 20px; }
.denied-content p { color: #64748B; margin-bottom: 30px; }
.loading-overlay { display: flex; justify-content: center; align-items: center; height: 100vh; background: #f8f9fc; width: 100%; }
.loading-content { text-align: center; }
.loading-content p { margin-top: 15px; color: var(--text-secondary); }
.main-wrapper { flex: 1; display: flex; flex-direction: column; overflow: hidden; position: relative; }
.content-main { flex: 1; padding: 25px; overflow-y: auto; }
.apply-section { background: white; border-radius: 12px; padding: 25px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); margin-top: 20px; }
.apply-item { display: flex; justify-content: space-between; align-items: center; padding: 20px 0; border-bottom: 1px solid #eee; }
.apply-item:last-child { border-bottom: none; }
.apply-info { flex: 1; text-align: left; }
.apply-title { font-weight: bold; font-size: 16px; color: #333; margin-bottom: 5px; }
.apply-desc { font-size: 14px; color: #666; }
.apply-btn { min-width: 120px; padding: 10px 20px; border-radius: 8px; font-weight: 500; cursor: pointer; text-align: center; transition: all 0.3s ease; }
.apply-btn-primary { background-color: var(--primary-color); color: white; border: 1px solid var(--primary-color); }
.apply-btn-primary:hover { background-color: #3B82F6; border-color: #3B82F6; }
.apply-btn-secondary { background-color: white; color: var(--primary-color); border: 1px solid var(--primary-color); }
.apply-btn-secondary:hover { background-color: #eff6ff; }
.terms-dialog .el-dialog__body { padding: 0; overflow: hidden; }
.terms-header { padding: 20px 30px; background: var(--bg-gray); border-bottom: 1px solid var(--border-color); font-weight: bold; text-align: center; color: var(--primary-color); }
.terms-content { padding: 30px; max-height: 50vh; overflow-y: auto; line-height: 1.8; font-size: 14px; color: var(--text-primary); text-align: left; }
.terms-footer { padding: 20px 30px; background: var(--bg-gray); border-top: 1px solid var(--border-color); display: flex; align-items: center; justify-content: space-between; }
.terms-checkbox { display: flex; align-items: flex-start; gap: 8px; }
.terms-checkbox input[type="checkbox"] { margin-top: 3px; }
.terms-checkbox-label { font-size: 11px; color: var(--text-secondary); }
.terms-checkbox-label span { color: var(--text-error); }
.terms-actions { display: flex; gap: 10px; }
.terms-cancel { flex: 1; background: white; border: 1px solid #ddd; color: var(--text-secondary); }
.terms-accept { flex: 1; background: var(--primary-color); border: none; color: white; }
.terms-accept:disabled { background: #93c5fd; cursor: not-allowed; }
.application-form-dialog .el-dialog { width: 1400px !important; max-width: 95vw; }
.application-form-dialog .el-dialog__body { padding: 30px; background: var(--bg-white); max-height: 80vh; overflow-y: auto; }
.form-section { margin-bottom: 30px; padding-bottom: 20px; border-bottom: 1px solid var(--border-color); }
.section-title { font-size: 18px; font-weight: bold; color: var(--primary-color); margin-bottom: 20px; display: flex; align-items: center; }
.section-title::before { content: ''; display: inline-block; width: 4px; height: 20px; background: var(--accent-color); margin-right: 10px; border-radius: 2px; }
.form-group-title { font-size: 16px; font-weight: 600; color: var(--text-primary); margin-top: 10px; border-left: 3px solid var(--primary-color); padding-left: 10px; }
.part-a-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; }
.form-group { display: flex; flex-direction: column; }
.form-label { font-size: 14px; font-weight: 500; color: var(--text-primary); margin-bottom: 6px; }
.form-input { padding: 10px 12px; border: 1px solid var(--border-color); border-radius: 4px; font-size: 14px; color: var(--text-primary); transition: border-color 0.2s; }
.form-input:focus { outline: none; border-color: var(--primary-color); box-shadow: 0 0 0 2px rgba(30, 58, 138, 0.1); }
.large-input { width: 100%; min-height: 40px; padding: 10px 12px; }
.readonly-input { background-color: #f5f7fa !important; color: #6c757d; cursor: not-allowed; border-color: #e2e8f0; }
.required-input { border-left: 3px solid var(--accent-color); }
.upload-component { width: 100%; }
.card-preview { position: relative; width: 400px; height: 250px; margin-top: 15px; border-radius: 15px; overflow: hidden; box-shadow: 0 10px 20px rgba(0,0,0,0.2); }
.card-preview img { width: 100%; height: 100%; object-fit: cover; position: absolute; top: 0; left: 0; z-index: 1; }
.card-preview .logo-overlay { position: absolute; top: 40px; left: 50%; transform: translateX(-50%); height: 40px; width: auto; z-index: 2; }
.card-preview .name-overlay { position: absolute; top: 87%; left: 30px; transform: translateY(-50%); color: white; font-family: 'OCR A Std', monospace, sans-serif; font-size: 0.9rem; text-transform: uppercase; text-shadow: 1px 1px 2px rgba(0,0,0,0.6); z-index: 2; }
.preview-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
.preview-table th, .preview-table td { border: 1px solid var(--border-color); padding: 8px 12px; vertical-align: top; text-align: left; }
.preview-table th { width: 30%; background-color: #f5f7fa; font-weight: bold; }
.step-nav { display: flex; justify-content: center; margin: 20px 0 30px; gap: 30px; }
.step { display: flex; flex-direction: column; align-items: center; gap: 5px; }
.step-number { width: 30px; height: 30px; border-radius: 50%; background: #CBD5E1; color: #475569; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 14px; }
.step-number.active { background: var(--primary-color); color: white; }
.step-label { font-size: 12px; color: var(--text-secondary); }
.step-label.active { color: var(--primary-color); font-weight: 500; }
.step-connector { width: 50px; height: 2px; background: #CBD5E1; align-self: center; }
.step-connector.active { background: var(--primary-color); }
.form-footer { display: flex; justify-content: space-between; margin-top: 30px; padding-top: 20px; border-top: 1px solid var(--border-color); }
.form-btn { padding: 10px 24px; border-radius: 6px; font-size: 15px; font-weight: 500; cursor: pointer; transition: all 0.2s; border: none; }
.btn-prev { background: #F1F5F9; color: var(--text-primary); }
.btn-prev:hover { background: #E2E8F0; }
.btn-next, .btn-submit { background: var(--primary-color); color: white; }
.btn-next:hover, .btn-submit:hover { background: #3B82F6; }
.query-dialog .el-form-item__content { justify-content: flex-start; }
.login-input { width: 100%; }
@media (max-width: 768px) { .part-a-grid { grid-template-columns: 1fr; } }
</style>